<template>
  <el-row
    class="switBox"
    :class="[isDoor ? 'door-table' : '', (tableStyleField.isInitTable === false) && !isGetListData && isDoor ? 'empty-content' : '']"
    :style="{
      paddingLeft:isDoor?'':'10px',
      paddingRight:isDoor?'':'10px',
      '--cell-height': tableStyleField.listLineHeight || '32px',
      '--cell-lineHeight': tableStyleField.listLineHeight || '32px',
      height: getAllHeight
    }"
    ref="tableBox"
  >
    <el-row
      v-if="searchCriteria"
      class="tranHeight"
      v-loading="fullScreenLoading"
    >
      <div class="nav-top">
        <div class="top-set">
          <template v-if="!batchApproval">
            <!-- 区块链设置 -->
            <div class="blockchain" v-show="blockchainChange">
              <div class="upload">
                <el-button
                  size="small"
                  @click="blockchainChange = !blockchainChange"
                  >取消</el-button
                ><el-button
                  type="primary"
                  size="small"
                  @click="blockchainUpload"
                  >上传区块链</el-button
                >
              </div>
            </div>
            <!-- 搜索框 -->
            <div class="list-search">
              <el-input v-model="searchCriteria.key" style="width: 200px" :style="{ '--el-input-border-radius': '4px 0 0 4px' }" placeholder="搜索标题或发起人名称"  @keyup.enter="getDataList(0)">
                <template #prefix>
                  <i class="iconfont icon-sousuo"></i>
                </template>
              </el-input>
              <el-button type="primary" @click="getDataList(0)">搜索</el-button>
            </div>
            <!-- 显示设置 -->
            <el-button
              size="mini"
              plain
              @click="getuserreport"
              :disabled="listData && listData.data.length > 0 ? false : true"
              style="color: #333333; font-size: 14px"
              :style="{ '--el-button-disabled-border-color': 'transparent' }"
              v-show="!blockchainChange"
            >
              <i class="iconfont icon-shezhi" style="color: #f09a38"></i>
              显示设置
            </el-button>
            <!-- 批量操作 -->
            <div
              class="batch"
              v-show="!blockchainChange"
              v-if="approvalId != '10116'"
            >
              <i class="iconfont icon-piliangcaozuo" style="color: #4e86ff"></i>
              <el-dropdown
                @command="handleCommand"
                placement="bottom-start"
                trigger="click"
              >
                <span class="el-dropdown-link">
                  <span class="title">批量操作</span>
                  <i class="iconfont icon-gengduo" style="font-size: 8px"></i>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="批量导入" v-if="widgetDataObj.import">批量导入</el-dropdown-item>
                    <el-dropdown-item command="批量删除" v-if="widgetDataObj.delete">批量删除</el-dropdown-item>
                    <el-dropdown-item command="批量修改" v-if="widgetDataObj.batchupdate">批量修改</el-dropdown-item>
                    <el-dropdown-item command="批量导出报表" v-if="panduanShow(listData) && widgetDataObj.export">批量导出报表</el-dropdown-item>
                    <el-dropdown-item command="批量导出附件" v-if="panduanShow(listData) && widgetDataObj.exportmyfile">批量导出附件</el-dropdown-item>
                    <el-dropdown-item command="上传区块链" v-if="widgetDataObj.userId && widgetDataObj.uploadmyblockchainid === true && activeTypeName === 0">上传区块链</el-dropdown-item>
                    <el-dropdown-item v-if="batchadd" command="4">批量审批</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </template>
          <!-- 数据筛选 -->
          <el-button
            type="text"
            style="color: #333333"
            class="nav-top-filter"
            @click="isFilter = true"
          >
            <i
              class="iconfont icon-shaixuanmian"
              style="color: #19b359; font-size: 14px; margin-right: 3px"
            ></i>
            <span>数据筛选</span>
            <i style="font-size: 8px" class="iconfont icon-gengduo" />
          </el-button>
          <template v-if="batchApproval">
            <el-button size="small" @click="batchApproval = false"
              >取消</el-button
            >
            <el-button size="small" @click="allApprove(true)"
              >全部处理</el-button
            >
            <el-button size="small" @click="allApprove(false)" type="success"
              >处理选中</el-button
            >
          </template>
        </div>
      </div>
    </el-row>
    <!-- style="padding-bottom: 10px; height: 100%" -->
    <el-row
      :style="{
        height: getTableH,
        paddingBottom: isDoor ? '0px' : '10px',
        width: '100%',
      }"
    >
      <template v-if="listData">
        <!-- :height="checkSyllable ? '100%' : tableHeight2 - 185" -->
        <template v-if="titleForRow && $refs.transaction && $refs.tabelColRef">
          <customRow :isAppenTodo="(clickEffect.todoNav === 'open' || clickEffect === undefined) && !todoLengthZero" :isNumFixed="isNumFixed" :clickEffect="clickEffect" :filedWidthList="filedWidthList" ref="customRow" :listData="listData.data || []" :tableRef="$refs.transaction" :titleRowConfig="titleRowConfig" :tableStyleField="tableStyleField" :listStyleConfig="listStyleConfig" :tabelColRef="$refs.tabelColRef" :checkSyllable="checkSyllable" :todoWidth="todoWidth" />
        </template>
        <el-table
          :height="titleForRow ? tableHeight : '100%'"
          :data="listData.data"
          :class="titleForRow ? 'custom-table-title' : ''"
          v-if="Number(switchNav) === Number(navIndex)"
          border
          :stripe="true"
          :header-cell-style="{
            background: '#f8f9fb',
            color: '#333',
            fontWeight: 'normal',
          }"
          :cell-style="{
            height: tableStyleField.listLineHeight || '32px',
            lineHeight:tableStyleField.listLineHeight || '32px',
          }"
          ref="transaction"
          :key="uploadKey"
          :row-style="getRowStyle"
          @row-click="tableDetail"
          @cell-dblclick="(row, column, cell) => goTodoEdit({ row, column, interactive: 'doubleClick', cell })"
          @selection-change="handleSelectionChange"
          @row-contextmenu="rowContextmenu"
          @hook:mounted="tableMounted"
          :header-row-class-name="hideSecondLevelHeader"
          :header-cell-class-name="'header_style'"
          :row-class-name="upClass"
          >
          <template v-slot:empty>
            <template v-if="(tableStyleField.isInitTable === false) && !isGetListData && isDoor">
              <initPage :width="tableWidth" :config="initConfig" />
            </template>
            <template v-else>
              暂无数据
            </template>
          </template>
          <el-table-column
            type="selection"
            :selectable="selectableFun"
            class="selection-box"
            :index="9999"
            width="40"
          ></el-table-column>
          <el-table-column
            type="index"
            :width="getWidth('','num')"
            :min-width="getMinWidth"
            :index="indexMethods"
            :fixed="isNumFixed"
            v-if="tableStyleField.isSerialNumber"
            ref="tabelColRef"
          >
            <template v-slot:header>
              <div class="ellipsis" :style="[listStyleConfig.titleConfig]" style="text-align: left"> 序号 </div>
            </template>
            <template v-slot="scope">
              <div class="cell-item">
                <div style="width: 100%;" :style="[listStyleConfig.valueConfig]"> {{ scope.$index + 1 }} </div>
              </div>
            </template>
          </el-table-column>
          <template v-for="(val, valIdx) in tableKey" :key="val.title">
            <tableDetailCol
              :prop="val.title"
              :listTodoField="listTodoField"
              :activeCol="activeCol"
              :approvalId="approvalId"
              v-if="(val.isAppenFeild === undefined || val.isAppenFeild) && !val.isHide"
              :index="valIdx"
              :key="val.title"
              :label="val.type"
              :fixed="val.fixed"
              :column="val"
              :tableDetailData="listStyleConfig"
              :min-width="isFixed ? getWidth(val) : getMinWidth"
              :width="isFixed ? '' : getWidth(val)"
              :tableStyleField="tableStyleField"
              @handleEdit="handleDetailCol"
              @clearActiveCol="clearActiveCol"
              ref="tabelColRef"
            >
              <template v-slot:header>
                <div class="ellipsis door-header" :style="[listStyleConfig.titleConfig]" :title="val.name">
                  {{ showFiledName(val) }}
                  <OrderAndScreen @goSearch="$emit('goSearch', val, $event)" :info="val" v-if="isDoor" />
                  <i class="iconfont icon-you" :class="val.isOpen ? 'trans' : ''" v-if="isDoor && val.isViewOpen" @click="goOpenOver(val)"></i>
                  <span class="detail-custom-header" :style="{ left: val.type.includes('_detailscustom') ? '0' : '', right: !val.type.includes('_detailscustom') ? '0' : '' }" v-if="(val.filedInfo && val.filedInfo.detailed && val.filedInfo.detailed.displayEffect === 'horizontal') || (val.type.includes('_detailscustom') && val.customKey === 0)" @click="changeDetailsCustom(val)">
                    {{ val.type.includes('_detailscustom') ? '收起' : '展开' }}
                    <i class="iconfont" :class="!val.type.includes('_detailscustom') ? 'icon-xiangyouzhankai' : 'icon-xiangzuoshousuo'"></i>
                  </span>
                </div>
              </template>
              <!-- <template slot-scope="scope" v-if="(appenCol[valIdx] && appenCol[valIdx].isAppen) || val.fixed"> -->
              <template v-slot="scope">
                <div :ref="`${val.title}-columnRef`" :style="{ alignItems: val.type === 'textarea' && getResValue(getValue(scope, val), val, scope) ? 'flex-start' : '' }" class="cell-item" :class="showTodoList[val.title] && showTodoList[val.title].info.moveAppen ? 'todo-btn-show' : ''">
                  <div class="list-app-img" v-if="val.type === 'image' && scope.row[val.title]">
                    <div @click.stop class="list-app-img-item" :key="imgIndex" v-for="(img, imgIndex) in isJSON(scope.row[val.title])" >
                      <el-image
                        :class="scope.row.isEditTodo === true && curClickTitleType.title=== val.title ? 'todo-img' : ''"
                        :src="img.url ? img.url : $imgurl + img.response + '?accesstoken=' + filesConfig()"
                        :preview-src-list="[img.url ? img.url : $imgurl + img.response + '?accesstoken=' + filesConfig()]"
                        fit="cover" />
                        <div class="img-mask" v-if="scope.row.isEditTodo === true && curClickTitleType.title=== val.title">
                          <i class="el-icon-delete" @click="delUpload(imgIndex,isJSON(scope.row[val.title]),scope.row,showTodoList[val.title])"></i>
                        </div>
                    </div>
                    <div class="todo-upload" @click.stop v-if="scope.row.isEditTodo === true && curClickTitleType.title=== val.title">
                      <el-upload
                        :action="$url+'/userfile/upload?accesstoken=' + token"
                        :data="{accesstoken: token}"
                        :show-file-list="false"
                        :on-success="(file)=>uploadSuccess(file, isJSON(scope.row[val.title]), scope.row, showTodoList[val.title])"
                        :before-upload="beforeImgUpload">
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </div>
                  </div>
                  <template v-else-if="val.type === 'file'">
                    <div class="img-file" :style="{ flexWrap: isJSON(scope.row[val.title]) && isJSON(scope.row[val.title]).length === 1 ? 'nowrap' : '' }">
                      <div v-for="(item2,idx2) in isJSON(scope.row[val.title])" :key="idx2" class="img-file-style" style="width: 100%;">
                        <i class="iconfont icon-wenjianfujian"></i>
                        <span @click.stop="goPreview(item2,false)" type="primary" :style="{ fontSize: listStyleConfig.valueConfig.fontSize }" style="width: fit-content;" class="img-file-content">
                          {{ strImgAndFileData(item2) }}
                        </span>
                        <span @click.stop="goPreview(item2,true)" type="primary" class="img-file-icon">
                          <i class="iconfont icon-xiazai2x"></i>
                        </span>
                        <i 
                          v-if="scope.row.isEditTodo === true && curClickTitleType.title=== val.title"
                          class="el-icon-delete"
                          @click.stop="delUpload(idx2,isJSON(scope.row[val.title]),scope.row,showTodoList[val.title])"
                        ></i>
                        <el-link 
                          v-if="getFileFormat(item2.response)"
                          type="primary" 
                          style="margin-left: 5px;"
                          @click.stop="playFun(item2)">
                          <i class="iconfont icon-bofang"></i>
                        </el-link>
                      </div>
                      <div class="todo-upload" @click.stop v-if="scope.row.isEditTodo === true && curClickTitleType.title=== val.title">
                        <el-upload
                          :action="$url+'/userfile/upload?accesstoken=' + token"
                          :data="{accesstoken: token}"
                          :show-file-list="false"
                          :limit="Number(showTodoList[val.title].upNumber)"
                          :multiple="true"
                          :on-progress="onProgress"
                          :before-upload="(file)=>beforeFileUpload(file,showTodoList[val.title])"
                          :on-success="(file)=>uploadSuccess(file, isJSON(scope.row[val.title]), scope.row, showTodoList[val.title])">
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="val.type.includes('_detailscustom')">
                    <div class="detail-custom-content" :style="[tableLine]">
                      <template v-for="(detail, _idx) in isJSON(scope.row[val.title])" :key="_idx">
                        <div class="detail-custom-content-item" @dblclick="detailCustomClick({ value: detail, row: scope.row, parent: val, e: $event, isTodo: showTodoList[detail.title] && showTodoList[detail.title].info.interactive === 'doubleClick' })" :style="[listStyleConfig.valueConfig, { justifyContent: getConfigCenter(listStyleConfig.valueConfig.textAlign) }]">
                          <template v-if="customDetailValue.title === detail.title && customDetailValue.parent && customDetailValue.parent.title === val.title && scope.row.approvingId === customDetailValue.approvingId">
                            <todoEdit ref="todoEditRef" :appendToBody="false" @change="todoChange" @reset="todoReset" :approvalId="approvalId" />
                          </template>
                          <template v-else>
                            <span class="door-ellipsis" @dblclick.stop="detailCustomClick({ value: detail, row: scope.row, parent: val, e: $event, isParent: true, isTodo: showTodoList[detail.title] && showTodoList[detail.title].info.interactive === 'doubleClick' })">
                              {{ getCustomDetailValue(detail.value) }}
                            </span>
                          </template>
                          <buttonStyle
                            class="list-todo-btn"
                            v-if="tableStyleField.isTodoList && showTodoList[detail.title] && showTodoList[detail.title].info.interactive === 'buttonClick'"
                            :info="{ info:showTodoList[detail.title].info }"
                            @click.stop="detailCustomClick({ value: detail, row: scope.row, parent: val, e: $event, isParent: true, isTodo: showTodoList[detail.title].info.interactive === 'buttonClick', isAncestor: true })" />
                        </div>
                      </template>
                    </div>
                  </template>
                  <div v-else-if="val.type === 'relation-check'">
                    <tableRead v-if="getRelCheck(scope.row[val.title])" :config="{list:getRelCheck(scope.row[val.title]).top, title: scope.$index}" :formdata="getRelCheck(scope.row[val.title])" />
                    <template v-else>{{ strData(scope.row[val.title], val.encrypt) }}</template>
                  </div>
                  <div v-else-if="val.type === 'number'" style="display: flex;width: 100%;" :style="{ justifyContent: getConfigCenter(listStyleConfig.valueConfig.textAlign) }">
                    <div v-if="scope.row.isEditTodo === true && curClickTitleType.title=== val.title">
                      <template v-if="isWYFN(showTodoList[val.title])">
                        <el-input-number 
                          @input="wyNumChangeValue({val:$event, item:showTodoList[val.title], row:scope.row})" 
                          @blur="wyNumChangeValue({val:$event, item:showTodoList[val.title], row:scope.row})"
                          :model-value="getNumberVal(scope.row[val.title], showTodoList[val.title])" 
                          controls-position="right"
                          class="todo-number todo-number-wy"
                          @click.stop
                          :placeholder="showTodoList[val.title].placeholder"
                          :min="showTodoList[val.title].min"
                          :max="showTodoList[val.title].max"/>
                          万元
                      </template>
                      <el-input-number 
                        v-else
                        @input="changeValue({val:$event, item:showTodoList[val.title], row:scope.row})" 
                        :model-value="toDecimal(scope.row[val.title])" 
                        @blur="changeValue({val:$event, item:showTodoList[val.title], row:scope.row})"
                        controls-position="right"
                        class="todo-number"
                        @click.stop
                        :placeholder="showTodoList[val.title].placeholder"
                        :min="showTodoList[val.title].min"
                        :max="showTodoList[val.title].max"/>
                    </div>
                    <template v-else>
                      <div id="tableContent" class="table-content" :style="[tableLine, listStyleConfig.valueConfig, labelColor(getValue(scope, val), val), numFormatStyle(getValue(scope, val), val), {  color: getResValue(toDecimal(scope.row[val.title]), val) + '' ? '' : '#C0C4CC' }]">
                        <span :style="{ color: getResValue(toDecimal(scope.row[val.title]), val) ? '' : '#C0C4CC' }">
                          {{ getResValue(toDecimal(scope.row[val.title]), val) === 'zero' ? 0 : (getResValue(toDecimal(scope.row[val.title]), val) || getPlaceholder(val)) }}
                        </span>
                      </div>
                    </template>
                  </div>
                  <div v-else-if="val.type === 'query'">
                    <template v-if="scope.row[val.title] === ''">
                      <div class="btn-query" @click.stop="queryData(scope.row, val)">
                        <i class="iconfont icon-sousuo" />
                        点击查询
                      </div>
                    </template>
                    <template v-else>
                      <template v-if="typeof scope.row[val.title] == 'object'">
                        <p v-for="(item, index) in scope.row[val.title]" :key="index">{{index+1}}.{{item}}</p>
                      </template>
                      <span v-else>{{scope.row[val.title]}}</span>
                    </template>
                  </div>
                  <div v-else-if="val.type === 'location'">
                    {{ getLocationVal(scope.row[val.title]) }}
                  </div>
                  <div v-else style="width: 100%;margin: auto 0;" :style="{ height: val.type === 'textarea' && scope.row.isEditTodo === true && curClickTitleType.title=== val.title ? '100%' : '' }">
                    <div
                      v-if="val.title === '状态'"
                      :class="statusFun(scope.row['status'])"
                      :style="[delValueColor, labelColor(scope.row[val.title], val), {justifyContent: getConfigCenter(listStyleConfig.valueConfig.textAlign)}]"
                      class="status-class"
                    >{{ scope.row[val.title] }}</div>
                    <div
                      v-else-if="val.title === '归档状态'"
                      :style="[tableLine, listStyleConfig.valueConfig, labelColor(getArchive(scope.row), val), {justifyContent: getConfigCenter(listStyleConfig.valueConfig.textAlign)}]"
                      class="status-class"
                    >{{ getArchive(scope.row) }}</div>
                    <!-- 明细列表 -->
                    <div class="rich-text" v-else-if="['details', 'richTextWid'].includes(val.type)">
                      <div class="rich-text-style" :style="[listStyleConfig.valueConfig, { justifyContent: getConfigCenter(listStyleConfig.valueConfig.textAlign) }]" @click.stop="openRichAndDetails(scope.row, val)">
                        <i class="iconfont icon-shujuchaxun"></i>
                        <span class="text">{{ tableStyleField.isTodoList && showTodoList[val.title] && showTodoList[val.title].info ? showTodoList[val.title].info.text || '请点击查看' : '请点击查看'  }}</span>
                      </div>
                    </div>
                    <div class="flex-w-h-full" :style="{ justifyContent: getConfigCenter(listStyleConfig.valueConfig.textAlign) }" v-else-if="isDoor && val.type === 'radio' && showTodoList && showTodoList[val.title] && showTodoList[val.title].types === 4 && tableStyleField.isTodoList && showTodoList[val.title]">
                      <div class="radio-switch" @click.stop>
                        <template v-if="showTodoList[val.title].switchStyle && showTodoList[val.title].switchStyle === 3">
                          <div :class="['radio-checkbox', scope.row[val.title] === getSwitchColor({ele: showTodoList[val.title], type: 'active',isGet: true}) ? 'radio-checkbox-active' : '']" @click="upCheckbox({ val: scope.row[val.title] === getSwitchColor({ele: showTodoList[val.title], type: 'active',isGet: true}) ? getSwitchColor({ele: showTodoList[val.title], type: 'inactive',isGet: true}) : getSwitchColor({ele: showTodoList[val.title], type: 'active',isGet: true}), item: showTodoList[val.title], row: scope.row, title: val.title })">
                            <el-icon class="iconfont">
                              <Check />
                            </el-icon>
                          </div>
                        </template>
                        <el-switch v-else
                          :active-value="getSwitchColor({ele: showTodoList[val.title], type: 'active',isGet: true})"
                          :inactive-value="getSwitchColor({ele: showTodoList[val.title], type: 'inactive',isGet: true})"
                          :active-color="getSwitchColor({ele: showTodoList[val.title], type: 'active'})"
                          :inactive-color="getSwitchColor({ele: showTodoList[val.title], type: 'inactive'})"
                          :inactive-text="showTodoList[val.title].switchStyle === 1 ? '' : getSwitchColor({ele: showTodoList[val.title], type: 'inactive', isGet: true})"
                          :active-text="showTodoList[val.title].switchStyle === 1 ? '' : getSwitchColor({ele: showTodoList[val.title], type: 'active', isGet: true})"
                          :model-value="getResValue(strData(scope.row[val.title], val.encrypt), val)"
                          @change="changeRadioValue({val:$event, item: showTodoList[val.title], row: scope.row })"
                        />
                      </div>
                    </div>
                    <div v-else-if="val.type === 'radio' && val.sels && val.types && val.types === 6">
                      <radioXing :sels="val.sels" :value="scope.row[val.title]" :edit="!!(tableStyleField.isTodoList && showTodoList[val.title])" @upXing="changeRadioValue({val:$event, item:showTodoList[val.title], row:scope.row})" />
                    </div>
                    <template v-else>
                      <template v-if="scope.row.isEditTodo === true && curClickTitleType.title=== val.title">
                        <div v-if="val.type === 'checkbox'" class="flex-w-h-full" :style="{ justifyContent: getConfigCenter(listStyleConfig.valueConfig.textAlign) }">
                          <el-select 
                            ref="todoSelect"
                            :placeholder="showTodoList[val.title].placeholder" 
                            clearable
                            collapse-tags filterable multiple class="todo-select" 
                            @change="changeValue({val:$event, item:showTodoList[val.title], row:scope.row})" 
                            v-if="showTodoList[val.title].types !== 4" 
                            :model-value="getResValue(strData(scope.row[val.title], val.encrypt), val) === '' ? [] : getResValue(strData(scope.row[val.title], val.encrypt), val).split(',')">
                              <el-option v-for="(sels, selsIndex) in objSels(showTodoList[val.title].sels)" :key="selsIndex" :label="sels" :value="sels" />
                          </el-select>
                        </div>
                        <div v-else-if="val.type === 'radio'" class="flex-w-h-full" :style="{ justifyContent: getConfigCenter(listStyleConfig.valueConfig.textAlign) }" @click.stop>
                          <el-select
                            class="todo-select" 
                            ref="todoSelect"
                            filterable
                            clearable
                            @change="changeRadioValue({val:$event, item:showTodoList[val.title], row:scope.row}, 'other')" 
                            v-if="showTodoList[val.title].types !== 4" 
                            :model-value="getResValue(strData(scope.row[val.title], val.encrypt), val)">
                              <el-option v-for="(sels, selsIndex) in objSels(showTodoList[val.title].sels)" :key="selsIndex" :label="sels.label || sels" :value="sels.value || sels"></el-option>
                            </el-select>
                            <div class="radio-switch" v-else-if="Number(showTodoList[val.title].types) === 4">
                              <template v-if="showTodoList[val.title].switchStyle && showTodoList[val.title].switchStyle === 3">{{ scope.row[val.title] }}
                                <div :class="['radio-checkbox', scope.row[val.title] === getSwitchColor({ele: showTodoList[val.title], type: 'active',isGet: true}) ? 'radio-checkbox-active' : '']" @click="upCheckbox({ val: scope.row[val.title] === getSwitchColor({ele: showTodoList[val.title], type: 'active',isGet: true}) ? getSwitchColor({ele: showTodoList[val.title], type: 'inactive',isGet: true}) : getSwitchColor({ele: showTodoList[val.title], type: 'active',isGet: true}), item: showTodoList[val.title], row: scope.row, title: val.title })">
                                  <el-icon><Check /></el-icon>
                                </div>
                              </template>
                              <el-switch v-else
                                :active-value="getSwitchColor({ele: showTodoList[val.title], type: 'active',isGet: true})"
                                :inactive-value="getSwitchColor({ele: showTodoList[val.title], type: 'inactive',isGet: true})"
                                :active-color="getSwitchColor({ele: showTodoList[val.title], type: 'active'})"
                                :inactive-color="getSwitchColor({ele: showTodoList[val.title], type: 'inactive'})"
                                :inactive-text="showTodoList[val.title].switchStyle === 1 ? '' : getSwitchColor({ele: showTodoList[val.title], type: 'inactive', isGet: true})"
                                :active-text="showTodoList[val.title].switchStyle === 1 ? '' : getSwitchColor({ele: showTodoList[val.title], type: 'active', isGet: true})"
                                :model-value="getResValue(strData(scope.row[val.title], val.encrypt), val)"
                                @change="changeRadioValue({val:$event, item: showTodoList[val.title], row: scope.row })"
                              />
                            </div>
                        </div>
                        <div v-else-if="val.type === 'text' || val.type === 'textarea'" :style="{ justifyContent: getConfigCenter(listStyleConfig.valueConfig.textAlign) }" style="height: 100%;align-items: center;display: flex;">
                          <el-input 
                            @click.stop 
                            ref="textInp" 
                            class="todo-inp"
                            :type="val.type"
                            @input="changeValue({val:$event, item:showTodoList[val.title], row:scope.row})"
                            @blur="changeValue({val:$event, item:showTodoList[val.title], row:scope.row})"
                            @keydown.enter="enterCheck({val:$event, item:showTodoList[val.title], row:scope.row})"
                            @keydown.ctrl.enter="controlEnterCheck({val:$event, item:showTodoList[val.title], row:scope.row})"
                            :model-value="getResValue(strData(scope.row[val.title], val.encrypt), val)"
                            :placeholder="val.type === 'textarea' ? 'Ctrl+Enter可换行' : showTodoList[val.title] && showTodoList[val.title].placeholder" />
                        </div>
                        <div v-else-if="val.type === 'date'" class="flex-w-h-full" :style="{ justifyContent: getConfigCenter(listStyleConfig.valueConfig.textAlign) }">
                          <el-date-picker
                            v-if="showTodoList[val.title].match == 'yyyy-MM-dd' || showTodoList[val.title].match == 'yyyy-MM-dd ww'"
                            :model-value="getResValue(getValue(scope, val), val)"
                            type="date"
                            class="todo-date"
                            ref="todoDate"
                            placeholder="选择日期"
                            format="YYYY-MM-DD"
                            value-format="YYYY-MM-DD"
                            style="width: 100%;"
                            @click.stop
                            :default-value="nextMonthFun(showTodoList[val.title].limit || '')"
                            @input="changeValue({val:$event, item:showTodoList[val.title], row:scope.row})"
                            :picker-options="pickerOptionsLimit(showTodoList[val.title])"
                            :disabled="showTodoList[val.title].exhibiIs"
                          ></el-date-picker>
                          <el-time-picker
                            v-else-if="showTodoList[val.title].match == 'HH:mm'"
                            v-model="scope.row[val.title]"
                            @change="changeValue({val: scope.row[val.title], item:showTodoList[val.title], row:scope.row})"
                            class="todo-date"
                            ref="todoDate"
                            value-format="HH:mm"
                            @click.stop
                            :picker-options="{ format: 'HH:mm' }"
                            :disabled="showTodoList[val.title].exhibiIs"
                            placeholder="任意时间点">
                          </el-time-picker>
                          <el-date-picker
                            v-else
                            :model-value="getResValue(getValue(scope, val), val)"
                            class="todo-date"
                            type="datetime"
                            ref="todoDate"
                            @click.stop
                            placeholder="选择日期时间"
                            style="width: 100%;"
                            @input="changeValue({val:$event, item:showTodoList[val.title], row:scope.row})"
                            :picker-options="pickerOptionsLimit(showTodoList[val.title])"
                            :default-value="nextMonthFun(showTodoList[val.title].limit || '')"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            :disabled="showTodoList[val.title].exhibiIs"
                          ></el-date-picker>
                        </div>
                        <div v-else-if="['relation-user','organization','roule'].indexOf(val.type) !== -1" class="flex-w-h-full" :style="{ justifyContent: getConfigCenter(listStyleConfig.valueConfig.textAlign) }">
                          <el-input 
                            class="todo-inp"
                            readonly
                            @click.stop="toGetValue({val:getResValue(getValue(scope, val), val), item: showTodoList[val.title], row:scope.row})"
                            :model-value="getResValue(getValue(scope, val), val)" 
                            :placeholder="showTodoList[val.title] && showTodoList[val.title].placeholder || '选择添加联系人'"
                          >
                            <template #prefix>
                              <i class="el-input__icon iconfont" :class="todoIcon[val.type]"></i>
                            </template>
                          </el-input>
                        </div>
                        <div v-else-if="val.type === 'new-rel-radio'" class="flex-w-h-full" :style="{ justifyContent: getConfigCenter(listStyleConfig.valueConfig.textAlign) }">
                          <newRelRadio
                            class="todo-select"
                            :bindVal="{
                              [`${val.title}_${val.type}`]: scope.row[val.title]
                            }"
                            :formdata="{
                              [`${val.title}_${val.type}`]: scope.row[val.title]
                            }"
                            :userHide="{}"
                            :isMom="false"
                            :isTodo="true"
                            :approvalId="approvalId"
                            @changeRefTodo="changeValue({val:$event, item:showTodoList[val.title], row:scope.row})"
                            :relRadio="showTodoList[val.title]">
                          </newRelRadio>
                        </div>
                      </template>
                      <div v-else class="flex-w-h-full" :style="{ justifyContent: getConfigCenter(listStyleConfig.valueConfig.textAlign) }">
                        <template v-if="!isDoor && val.type === 'radio' && fileProperty && fileProperty[val.title] && fileProperty[val.title].types === 4">
                          <div class="radio-switch" @click.stop>
                            <template v-if="fileProperty[val.title].switchStyle && fileProperty[val.title].switchStyle === 3">
                              <div :class="['radio-checkbox', scope.row[val.title] === getSwitchColor({ele: fileProperty[val.title], type: 'active',isGet: true}) ? 'radio-checkbox-active' : '']" @click="upCheckbox({ val: scope.row[val.title] === getSwitchColor({ele: fileProperty[val.title], type: 'active',isGet: true}) ? getSwitchColor({ele: fileProperty[val.title], type: 'inactive',isGet: true}) : getSwitchColor({ele: fileProperty[val.title], type: 'active',isGet: true}), item: fileProperty[val.title], row: scope.row, title: val.title })">
                                <el-icon><Check /></el-icon>
                              </div>
                            </template>
                            <el-switch v-else
                              :active-value="getSwitchColor({ele: fileProperty[val.title], type: 'active',isGet: true})"
                              :inactive-value="getSwitchColor({ele: fileProperty[val.title], type: 'inactive',isGet: true})"
                              :active-color="getSwitchColor({ele: fileProperty[val.title], type: 'active'})"
                              :inactive-color="getSwitchColor({ele: fileProperty[val.title], type: 'inactive'})"
                              :inactive-text="fileProperty[val.title].switchStyle === 1 ? '' : getSwitchColor({ele: fileProperty[val.title], type: 'inactive', isGet: true})"
                              :active-text="fileProperty[val.title].switchStyle === 1 ? '' : getSwitchColor({ele: fileProperty[val.title], type: 'active', isGet: true})"
                              :model-value="getResValue(strData(scope.row[val.title], val.encrypt), val)"
                              @change="changeRadioValue({val:$event, item: fileProperty[val.title], row: scope.row})"
                            />
                          </div>
                        </template>
                        <div
                          v-else
                          :class="[getContentClass(val)]"
                          :style="[tableLine, numFormatStyle(getValue(scope, val), val), listStyleConfig.valueConfig, labelColor(getValue(scope, val), val)]"
                          :title="getResValue(getValue(scope, val), val, scope)"
                          id="tableContent"
                          class="table-content"
                          style="height: 100%;"
                          :ref="`${val.title}-column`"
                        >
                          <template v-if="val.type === 'date' && val.match && val.match === 'yyyy-MM-dd ww'">
                            {{ getResValue(getValue(scope, val), val) || getPlaceholder(val) }} {{'星期' + getWeek(getValue(scope, val))}}
                          </template>
                          <template v-else-if="val.type === 'date'">
                            {{ getTimeLabels(val, scope) }}
                          </template>
                          <template v-else-if="val.type === 'relation-user'">
                            <template v-if="Array.isArray(scope.row[val.title])">
                              <span class="relation-user-content" v-for="item in scope.row[val.title]" :key="item.userId">
                                <relationUserInfo v-if="val.isMoreInfo" :info="item" :moreInfo="val.moreInfoArr" :checkedInfo="showTodoList[val.title] && showTodoList[val.title].checkKey" :isNewInfo="item.isNewData" iconColor='#4E86FF' />
                                <template v-else>{{ item.realname }}</template>
                              </span>
                            </template>
                          </template>
                          <template v-else>
                            <span :style="{ whiteSpace: val.type === 'textarea' ? 'pre-wrap' : '', color: getResValue(getValue(scope, val), val, scope) ? '' : '#C0C4CC' }" v-if="val.type === 'text' && isLinkObj[val.title]" class="text-link" @click.stop="openLinkText(getValue(scope, val))">{{ getResValue(getValue(scope, val), val) || getPlaceholder(val) }}</span>
                            <template v-else>
                              <span :style="{ whiteSpace: val.type === 'textarea' ? 'pre-wrap' : '', color: getResValue(getValue(scope, val), val, scope) ? '' : '#C0C4CC' }">{{ getResValue(getValue(scope, val), val, scope) || getPlaceholder(val) }}</span>
                            </template>
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                  <buttonStyle
                    class="list-todo-btn"
                    v-if="tableStyleField.isTodoList && showTodoList[val.title] && showTodoList[val.title].info.interactive === 'buttonClick' && !scope.row.isEditTodo && showTodoList[val.title].types !== 4 && !(['details', 'richTextWid'].includes(val.type))" 
                    :info="{ info:showTodoList[val.title].info }"
                    @click.stop="goTodoEdit({ row: scope.row, column: { property:val.title,label: val.type }, interactive: showTodoList[val.title].info.interactive, event: $event })" />
                </div>
              </template>
            </tableDetailCol> 
          </template>
          <template v-if="!isDoor">
            <el-table-column
              label="操作"
              width="120"
              fixed="right"
              align="center"
              v-if="
                (widgetDataObj &&
                (widgetDataObj.update ||
                  widgetDataObj.delete ||
                  widgetDataObj.archive))
              "
              style="z-index: 999"
            >
              <template v-slot="scope">
                <!-- 表单操作 v-if="blockchaiButtonShow(scope.row) === true" -->
                <div @click.stop :class="scope.row.hasOwnProperty('transfile') ? 'todo-grid todo-grid-four' : 'todo-grid'">
                  <el-tooltip
                    v-if="
                      scope.row.cochain &&
                      (scope.row.cochain === 1 || scope.row.cochain === 2)
                    "
                    class="item"
                    effect="dark"
                    content="已上区块链"
                    placement="top"
                  >
                    <!-- <img
                      src="https://bigdata.topeti.com/PCRepository/mainPlatform/link.svg"
                    /> -->
                    <i class="iconfont icon-guanliankongjian todo-icon-color"></i>
                  </el-tooltip>
                  <el-button
                    @click.stop="tableUpdate(scope.row)"
                    type="text"
                    v-if="isDelAndEdit(scope.row, 'update')"
                    size="small"
                    style="color: #267cff; font-size: 14px"
                    ><i class="iconfont icon-bianji todo-icon-color"
                  /></el-button>
                  <el-button
                    @click.stop="deleteRow(1, scope.$index)"
                    type="text"
                    v-if="isDelAndEdit(scope.row, 'delete')"
                    size="small"
                    style="color: #e5283f; font-size: 14px"
                    ><i class="iconfont icon-shanchu5"
                  /></el-button>
                  <el-button
                    v-if="widgetDataObj.myoplog"
                    @click.stop="viewLogFun(scope.row)"
                    type="text"
                    size="small"
                    style="color: #f7a114; font-size: 14px"
                    ><i class="iconfont icon-chakanxiangqing1 todo-icon-color"
                  /></el-button>
                  <div class="table-todo-img-tip" v-if="scope.row.hasOwnProperty('transfile')">
                    <el-tooltip
                      effect="dark"
                      :content="scope.row.transfile ? '解析成功' : '解析失败'"
                      placement="bottom"
                    >
                      <img
                        @click.stop
                        style="display:block;width:18px;height:17px;margin-left:5px;"
                        :src="'https://bigdata.topeti.com/PCRepository/mainPlatform/analysis-' + (scope.row.transfile ? 'success.svg' : 'fail.svg')"
                      />
                    </el-tooltip>  
                  </div>
                  <template v-if="widgetDataObj.oqrcore">
                    <el-dropdown @command="onQrcodeCommand">
                      <span class="el-dropdown-link" title="数据二维码">
                        <i class="iconfont icon-erweima- qrcode todo-icon-color"></i>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <template v-if="widgetDataObj.qrcodetypes">
                            <el-dropdown-item
                              v-if="widgetDataObj.qrcodetypes.includes(2)"
                              :command="{
                                channel: 'mini',
                                type: 1,
                                approvingId: scope.row.approvingId,
                                customTitle: scope.row['自定义标题'],
                                approvalId: approvalId,
                              }"
                              >生成小程序端静态二维码</el-dropdown-item
                            >
                            <el-dropdown-item
                              v-if="widgetDataObj.qrcodetypes.includes(3)"
                              :command="{
                                channel: 'mini',
                                type: 2,
                                approvingId: scope.row.approvingId,
                                customTitle: scope.row['自定义标题'],
                                approvalId: approvalId,
                              }"
                              >生成小程序端动态二维码</el-dropdown-item
                            >
                            <el-dropdown-item
                              v-if="widgetDataObj.qrcodetypes.includes(4)"
                              :command="{
                                channel: 'h5',
                                type: 1,
                                approvingId: scope.row.approvingId,
                                customTitle: scope.row['自定义标题'],
                                approvalId: approvalId,
                              }"
                              >生成H5端静态二维码</el-dropdown-item
                            >
                            <el-dropdown-item
                              v-if="widgetDataObj.qrcodetypes.includes(5)"
                              :command="{
                                channel: 'h5',
                                type: 2,
                                approvingId: scope.row.approvingId,
                                customTitle: scope.row['自定义标题'],
                                approvalId: approvalId,
                              }"
                              >生成H5端动态二维码</el-dropdown-item
                            >
                          </template>
                          <template v-else>
                            <el-dropdown-item
                              v-if="widgetDataObj.oqrcore === 1 || widgetDataObj.oqrcore === 2"
                              :command="{
                                channel: 'mini',
                                type: 1,
                                approvingId: scope.row.approvingId,
                                customTitle: scope.row['自定义标题'],
                                approvalId: approvalId,
                              }"
                              >生成小程序端静态二维码</el-dropdown-item
                            >
                            <el-dropdown-item
                              v-if="widgetDataObj.oqrcore === 1 || widgetDataObj.oqrcore === 3"
                              :command="{
                                channel: 'mini',
                                type: 2,
                                approvingId: scope.row.approvingId,
                                customTitle: scope.row['自定义标题'],
                                approvalId: approvalId,
                              }"
                              >生成小程序端动态二维码</el-dropdown-item
                            >
                            <el-dropdown-item
                              v-if="widgetDataObj.oqrcore === 1 || widgetDataObj.oqrcore === 4"
                              :command="{
                                channel: 'h5',
                                type: 1,
                                approvingId: scope.row.approvingId,
                                customTitle: scope.row['自定义标题'],
                                approvalId: approvalId,
                              }"
                              >生成H5端静态二维码</el-dropdown-item
                            >
                            <el-dropdown-item
                              v-if="widgetDataObj.oqrcore === 1 || widgetDataObj.oqrcore === 5"
                              :command="{
                                channel: 'h5',
                                type: 2,
                                approvingId: scope.row.approvingId,
                                customTitle: scope.row['自定义标题'],
                                approvalId: approvalId,
                              }"
                              >生成H5端动态二维码</el-dropdown-item
                            >
                          </template>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </template>
                  <template v-if="widgetDataObj.lookqrcode">
                    <el-dropdown @command="onQrcodeCommand">
                      <span class="el-dropdown-link" title="查看二维码">
                        <i class="iconfont icon-erweima- qrcode todo-icon-color"></i>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <template v-if="widgetDataObj.lookqrcodetypes">
                            <el-dropdown-item
                              v-if="widgetDataObj.lookqrcodetypes.includes(1)"
                              :command="{
                                channel: 'mini',
                                type: 1,
                                mode: 'look', // 用来判断是不是查看的二维码
                                approvingId: scope.row.approvingId,
                                customTitle: scope.row['自定义标题'],
                                approvalId: approvalId,
                                userApprovingId: scope.row.userApprovingId
                              }"
                              >生成小程序查看二维码</el-dropdown-item
                            >
                            <el-dropdown-item
                              v-if="widgetDataObj.lookqrcodetypes.includes(2)"
                              :command="{
                                channel: 'h5',
                                type: 1,
                                mode: 'look', // 用来判断是不是查看的二维码
                                approvingId: scope.row.approvingId,
                                customTitle: scope.row['自定义标题'],
                                approvalId: approvalId,
                                userApprovingId: scope.row.userApprovingId
                              }"
                              >生成H5端查看二维码</el-dropdown-item
                            >
                          </template>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </template>
                  <el-button
                    v-if="
                      JSON.stringify(scope.row.archive) && widgetDataObj.archive
                    "
                    type="text"
                    size="small"
                    @click.stop="archiveFun(scope.row)"
                    :title="scope.row.archive ? '解除归档' : '归档'"
                    :style="{ color: scope.row.archive ? '#9013FE' : '#999' }"
                    ><i class="iconfont icon-guidang"
                  /></el-button>
                </div>
                <!-- 区块链操作 -->
                <!--              <div v-else>已上区块链</div>-->
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <template v-if="(clickEffect.todoNav === 'open' || clickEffect === undefined) && !todoLengthZero">
              <el-table-column
                :width="todoWidth"
                align="center"
                fixed="right"
                style="z-index: 999"
              >
                <template v-slot:header>
                  <div class="ellipsis" :style="[listStyleConfig.titleConfig,{textAlign: 'center'}]"> 操作 </div>
                </template>
                <template v-slot="scope">
                  <div class="table-todo">
                    <btncomp v-for="comp in tableTodoListComp(scope)" 
                      :widgetDataObj="widgetDataObj"
                      size="16px"
                      :isTable="true"
                      :approvalId="approvalId"
                      :tableData="scope.row"
                      :tableListInfo="listInfo"
                      @openPrint="openPrint($event,scope.row)"
                      @edit-user-info="$emit('edit-user-info', $event, scope.row)"
                      @dataArchiving-btn="archiveFun(scope.row)" 
                      @qrCode-btn="qrcodeBtn($event,scope.row)" 
                      @blockchain-btn="blockchainBtn(scope.row)" 
                      @dataLog-btn="viewLogFun(scope.row)" 
                      @edit-btn="tableUpdate(scope.row, $event)" 
                      @todo-inside="$emit('todo-inside',{row:scope.row,insideInfo: $event})"
                      @open-appDialog="$emit('open-appDialog', $event)"
                      @todo-outside="$emit('todo-outside',{row:scope.row,insideInfo: $event})" 
                      @del-btn="deleteRow(1, scope.$index)" 
                      @custom-scene="$emit('custom-scene',$event)"
                      @openDataSync="$emit('openDataSync', $event)"
                      @tableDetail="(...arges)=>openDetailInfo(arges,scope.row)"
                      @app-print="appPrint($event, scope.row)"
                      @open-dictionary="$emit('open-dictionary',$event)"
                      @to-nav="$emit('to-nav',{ row:scope.row, insideInfo:$event} )"
                      @appPrint="$emit('appPrint', $event)"
                      @updateTable="$emit('updateTable', $event)"
                      @uploadBlock="$emit('uploadBlock', $event)"
                      @openAppInitiate="$emit('openAppInitiate', $event)"
                      @progress-show="$emit('progress-show', $event)"
                      @progress-status="$emit('progress-status', $event)"
                      :class="{
                        'dataArchiving': scope.row.archive && comp.id === 6
                      }"
                      :info="{info:comp}" :key="comp.id" class="table-todo-item">
                    </btncomp>
                    <div class="table-todo-img-tip" v-if="scope.row.hasOwnProperty('transfile')">
                      <el-tooltip
                        effect="dark"
                        :content="scope.row.transfile ? '解析成功' : '解析失败'"
                        placement="bottom"
                      >
                        <img
                          @click.stop
                          style="display:block;width:18px;height:17px;margin-left:5px;"
                          :src="'https://bigdata.topeti.com/PCRepository/mainPlatform/analysis-' + (scope.row.transfile ? 'success.svg' : 'fail.svg')"
                        />
                      </el-tooltip>  
                    </div>                    
                  </div>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </template>
      <template v-else>
        <p style="padding-top: 20px; text-align: center">暂无数据</p>
      </template>
      <div class="reload" v-if="isDoor && tableStyleField.isOpenReload !== false" @click="goReload" title="刷新数据">
        <i class="WSiconfont WSicon-zhongzhiicon"></i>
      </div>
    </el-row>
    <div
      class="page"
      :style="{ bottom: isDoor ? '-32px' : '', padding: isDoor ? '0' : '' }"
      v-if="listData && listData.data && listData.data.length !== 0 && isDoor ? tableStyleField.loadingMethod === 'pageCutting': listData && listData.total > 0"
    >
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="listData.pagesize"
        :page-sizes="pageSizes"
        :current-page="listData.currentPage ? listData.currentPage : 1"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listData.total"
      ></el-pagination>
    </div>
    <el-dialog
      :title="dialogFieldSet.title"
      v-model="dialogFieldVisible"
      class="dialognewclass dialog-nopadding"
      width="530px"
    >
      <el-row class="dialog-body">
        <el-checkbox-group v-model="checkShowSet" @change="fieldChange">
          <el-checkbox
            v-for="showSet in showSets"
            :label="showSet"
            :key="showSet.id"
            style="margin: 0 10px"
            :disabled="showSet.type == 'container' && dialogFieldSet.botton == 1 ? true : false"
            >{{ showSet.name }}</el-checkbox
          >
        </el-checkbox-group>
      </el-row>
      <el-row class="dialog-foot">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAllField"
          @change="fieldAllChange"
          >全选</el-checkbox
        >
        <div class="dialog-foot-btn">
          <el-button
            type="primary"
            @click="exportexcel"
            v-if="dialogFieldSet.botton == 0"
            >导出</el-button
          >
          <el-button type="primary" @click="FieldSubmit" v-else
            >确定</el-button
          >
          <el-button style="margin-left:10px;" @click="dialogFieldVisible = false"
            >取消</el-button
          >
        </div>
      </el-row>
    </el-dialog>
    <vue-qr-code ref="vueqrcoderef" v-if="dialogvueqr" />
    <oaExamineAudit
      ref="AuditOpenChild"
      :openType="componentType"
      :diaSize="diaSize"
      :viewDetailFun="detailOpenType"
      :tableStyleField="tableStyleField"
      v-on:sourceAudit="sourceAudit"
      @edit-btn="tableUpdate"
      @dataArchiving-btn="archiveFun" 
      @blockchain-btn="blockchainBtn" 
      @del-btn="(approvingId) => { deleteRow(3, approvingId) }" 
    ></oaExamineAudit>
    <!-- 批量下载附件 -->
    <accessory
      v-if="downLoadShow"
      ref="accessoryRef"
      :date="listData.data"
    ></accessory>
    <!-- 搜索 -->
    <transactionFilter
      v-model:isFilter="isFilter"
      v-model:condition="query"
      :approvalId="$route.query.approvalId || approvalId"
      @goFilter="goFilter"
    />
    <!-- 批量审批查看 -->
    <batchView
      v-if="isBatch"
      v-model:isView="isBatch"
      :info="{
        app: widgetDataObj,
        selected: multipleSelection,
        headerList: tableKey,
        searchInfo: searchCriteria,
      }"
      :allBatch="allBatch"
      @resetRefresh="batchRefresh"
    />
    <!-- 日志查看 -->
    <log
      v-model:isLogView="isViewLog"
      :approvalId="$route.query.approvalId || approvalId"
      :approvingId="logApprovingId"
    />
    <batchDialog
      v-model:visible="batch.visible"
      :date="batch"
      :approvalId="$route.query.approvalId || approvalId"
      @batch="batchRet"
    />
    <!-- 打印预览 -->
    <print-box
      ref="printBox" 
      :key=" 'print' + printBoxKey"
      v-model:isView="printBoxShow"
      v-model:isOpen="printBoxOpen"
      :title="printTitle" 
      :formdata="printFormdata"
      :detailConfig="printBoxConfig"
      :deptGroup="deptGroup"
      @close="printBoxKey++">
    </print-box>
    <!-- 联系人控件 -->
    <multiple-choice 
      ref="multipleChoiceRef" 
      v-on:fromMultipleChoice="fromMultipleChoice"
      v-show="isMultipleChoice">
    </multiple-choice>
    <allmultiple-choice
      ref="allMultipleChoiceRef"
      v-on:fromMultipleChoice="orgChoiceMethod"
      v-show="isAllMultipleChoice"
      :isSpace="isSpace"
    ></allmultiple-choice>
    <widgetLinkOpen ref="widgetLinkOpen" :linkConfig="linkconfig" diaSize="80%" />
    <richTextEdit :richTitle="tempRichAndDetailsName" :isReadonly="isRichTextReadonly" :width="`${approvalInfo.pdwidth || 60}%`" :isAppendRightTools="false" @submit="richTextEditCallBack" ref="richTextEdit" />
    <detailReadonly ref="detailReadonly" />
    <TodoEdit ref="todoEdit" @change="todoChange" :approvalId="approvalId" />
    <context-menu v-if="showMenu" :menu-items="tempBtnMenu" :position="menuPosition" @close="menuClose"  @item-click="handleMenuClick" />
    <swipeIndex ref="swipeIndexRef" @swipeRet="swipeRet" />
    <oaAddExamineInput
      v-model:isViews="addDataShow"
      :applyInfo="approvalInfo"
      :pageType="pageType"
      :coverVal="coverVal"
      :isAllAdd="isAllAdd"
      @updateTable="$emit('updateTable')"
    />
    <InstallProgress class="fullscreen-progress" :appendToBody="true" :visible="showProgress" text="文件上传中..." />
  </el-row>
</template>
<script>
import { sliceEncrypt, filePreview, filesConfig, getSwitchColor, linkedSetEvent, getOrgShowName } from "@/api/global.js";
import { uploaderFun, getConfigFromUrl, isJSON, thisNoTime, limitDate, isWY } from "@/api/utils";
import { axiosBase } from "@/api/api";
import oaExamineAudit from "../oaExamineAudit.vue";
import accessory from "./accessory.vue";
import { tableStatus } from "@/api/utils";
import vueQrCode from "@/components/clientSide/common/vueQrCode";
import DealPrintData from '@/components/common/detailEdit/utils/dealPrintData.utils.js'
import multipleChoice from "@/components/common/multipleChoice"; //组织结构和角色选择
import allmultipleChoice from "@/components/common/multipleChoice"; //组织角色选择（平台+空间）
import newRelRadio from "../formFillinPageChild/newRelRadio.vue";
import tableRead from '../formFillinPageChild/detailsTable/tableRead.vue'
import customRow from "@/components/schoolInstrument/mixins/customRow";
import { sheetDefaultConfig } from '@/components/common/detailEdit/detailConfig.js'
import { getLabelColor } from '@/api/instrumentControl'
import { getParamsLists, isConditionAppen, getUserParam, getDateValue, getTextValue, getNumValue, performTakss } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { isScrollAtBottom, isScrollAtRight, isValidateapprovaltimeswitch } from '@/components/schoolInstrument/mixins/utils'
import { getWeek } from '@/api/styleUtils'
import { getapifielddatalist, archivedata, deletebycondition, batchupdatedata } from "@/port/clientSide/workbench";
import { openapiGetoptions } from "@/port/admins/wordbook";
import { openapiGetapproval, getuserapprovinglist, getlinkeddatalist } from "@/port/clientSide/oaExamineAudit";
import { addcochain, updateapprovingbyfeild } from "@/port/clientSide/oaExamineAudit";
import { cloneDeep } from "lodash";
import btncomp from '@/components/schoolInstrument/component/mutual/component/button/index'
import buttonStyle from '@/components/schoolInstrument/component/mutual/component/button/buttonStyle'
import radioXing from '@/components/clientSide/formFillinPageChild/widgetCommon/radioXing.vue'
import { dealText } from '@/api/common'
import { ElMessage } from 'element-plus'
import initPage from "@/components/schoolInstrument/component/mutual/component/form/initPage.vue";
import OrderAndScreen from "@/components/common/orderAndScreen.vue";
import richTextEdit from '@/components/common/richTextEditDia.vue' // 富文本编辑
import detailReadonly from '@/components/common/detailReadonly.vue' // 详情只读
import TodoEdit from "@/components/schoolInstrument/component/mutual/component/form/todoEdit.vue";
import tableDetailCol  from '@/components/schoolInstrument/component/mutual/component/form/tableDetailCol.vue'
import contextMenu from '@/components/common/contextMenu.vue'
import qs from 'qs'
import { defineAsyncComponent } from "vue";

export default {
  name: "organizationComp",
  // props: [
  //   "navIndex",
  //   "openAction",//打开详情方式 old 原页面 new 新页面 dialog弹窗
  //   "activeTypeName",
  //   "approvalId",
  //   "batchadd",
  //   // mutual 调用
  //   "checkSyllable", //table头
  //   "listInfo", //table内容
  //   "jurisdiction", //table按钮权限
  //   "isDoor", // 判断是否从门户应用列表进入
  //   "tableStyleField"
  // ],
  props: {
    navIndex: Number,
    //打开详情方式 old 原页面 new 新页面 dialog弹窗
    openAction: String,
    activeTypeName: Number,
    pageId: String,
    approvalId: [Number, String],
    batchadd: Boolean,
    //table头
    checkSyllable: {
      type: Array,
      default:()=>([])
    },
    titleRowConfig: {
      type: Object,
      default:()=>({})
    },
    //table内容
    listInfo: {
      type:Object
    },
    jurisdiction: {
      type: [Object, Array]
    },
    pageList:{
      type: Object,
      default: ()=>({}) 
    },
    // 判断是否从门户应用列表进入
    isDoor: {
      type: Boolean,
      default:false
    },
    tableStyleField: {
      type: Object,
      default: () => ({})
    },
    // 门户点击效果
    clickEffect: {
      type: Object,
      default:()=>({})
    },
    tableTodoList: {
      type: Array,
      default:()=>([])
    },
    rightTodoList: {
      type: Array,
      default:()=>([])
    },
    // ai小易配置隐藏，则默认勾选全部数据
    aitableHide: {
      type: Boolean,
      default: false
    },
    // 表单样式
    listStyleConfig: {
      type:Object,
      default: () => {
        return {
          titleConfig: {},
          valueConfig: {}
        }
      }
    },
    listTodoConfig: {
      type:Array,
      default: () => ([])
    },
    fileProperty: {
      type: Object,
      default: null
    },
    initConfig:{
      type: Object,
      default: ()=>({})
    },
    filedWidthList:{
      type: Array,
      default: ()=>([])
    },
    isGetListData: {
      type:Boolean,
      default: false 
    },
    customDeskId: {
      type: [String, Number],
      default: 0
    },
    approvalInfo:{
      type: Object,
      default: ()=>({})
    },
    listTodoField:{
      type: Object,
      default: ()=>({})
    },
    pivotConfig: {
      type: Object,
      default: ()=>({})
    }
  },
  components: {
    oaExamineAudit,
    accessory,
    vueQrCode,
    initPage,
    buttonStyle,
    transactionFilter: defineAsyncComponent(() => import("./transationFilter/index")),
    batchView: defineAsyncComponent(() => import("./batchView/index")),
    log: defineAsyncComponent(() => import("./log/index")),
    batchDialog: defineAsyncComponent(() => import("./batchDialog/index")),
    btncomp,
    printBox: defineAsyncComponent(() => import("@/components/common/detailEdit/excel/printBox.vue")),
    tableRead,
    multipleChoice,
    allmultipleChoice,
    newRelRadio,
    radioXing,
    customRow,
    OrderAndScreen,
    relationUserInfo: defineAsyncComponent(() => import('@/components/clientSide/common/relationUserInfo')),
    widgetLinkOpen: defineAsyncComponent(() => import('@/components/clientSide/common/widgetLinkOpen.vue')),
    richTextEdit,
    detailReadonly,
    TodoEdit,
    tableDetailCol,
    contextMenu,
    swipeIndex: defineAsyncComponent(() => import("@/components/schoolInstrument/component/mutual/component/swipe/index.vue")),
    oaAddExamineInput: defineAsyncComponent(() => import('@/components/schoolInstrument/component/mutual/component/button/oaAddExamineInput.vue')),
    InstallProgress: defineAsyncComponent(() => import('@/components/common/installLoading.vue')),
  },
  filters: {
    cutOutText (value) {
      //获取两个时间的差别是几天
      return value.split("_")[0];
    },
  },
  data () {
    return {
      diaSize: '80%',
      componentType: 'dialog',
      todoIcon: {
        organization: 'icon-zuzhikongjian',
        roule: 'icon-jiaosekongjian',
        'relation-user': 'icon-lianxirenkongjian'
      },
      isAllMultipleChoice:false,
      // 是否显示联系人控件弹窗
      isMultipleChoice: false,
      // 当前修改后的数据 最终要提交的数据
      curValue: null,
      // 当前双击的单元格
      curRow: {},
      // 判断是否有在编辑状态
      isEditTodo:false,
      // 当前双击的类型
      curClickTitleType: { title:'', type:''},
      showTodoList: {},
      token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : '',
      tableHeight2: 100, //表格高度
      fullScreenLoading: false,
      userId: true, //个人报表或者学校报表
      menuListActive: 0,
      query: [], //搜索列表数据
      querys: "{}", //验证过滤使用，如果有过滤数据，就走这个过滤
      searchMore: false,
      activeName: "first",
      tableKey: [],
      showSets: [], //显示设置全部
      checkShowSet: [], //显示设置选中
      isIndeterminate: true, //全选使用
      dialogFieldVisible: false,
      dialogFieldSet: {
        title: "设置导出字段",
        botton: 0,
      },
      checkAllField: false,
      userReportId: null, //提交显示字段ID
      listData: null,
      searchDefault: null, //默认搜索用于清空搜索
      searchCriteria: null,
      switchNav: 0, //这个是用于取高度的下表
      // currentPage:1,//当前页码
      multipleSelection: [],
      widgetDataObj: {}, //控件数据
      //- 批量整合
      downLoadShow: false,
      dialogvueqr: false,
      //- 区块链按钮显示
      blockchainChange: false,
      uploadKey: 0,
      // 搜索
      isFilter: false,
      batchApproval: false, // 批量审批
      isBatch: false, // 是否打开批量审批弹窗
      allBatch: false, // 是否选择了全部审批
      // 查看日志
      isViewLog: false,
      logApprovingId: "",
      // 辨别配置使用
      approvalIds: "",
      // 批量修改等使用
      batch: {
        visible: false,
        title: "",
        operate: "",
      },
      // 是否是第一次点击编辑
      isFirstEdit: false,
      // 操作栏的宽度
      todoWidth:120,
      printBoxShow: false, // 打印预览数据的显示隐藏
      printBoxOpen: false, // 打印预览弹窗的显示隐藏
      printTitle: null,
      printBoxConfig: sheetDefaultConfig, // 传入打印盒子的配置
      printBoxKey: 0, // 用于刷新组件
      printFormdata: {}, // 传入打印盒子的数据
      workshopFormdata: {}, // 工坊的数据
      isSpace: false, // 是否从空间进入
      isUpace: false, // 是否从空间进入
      approvingId: null,
      // 数组长度是否为0
      todoLengthZero: false,
      deptGroup: {},
      // isLink 文本
      isLinkObj: {},
      // 链接配置
      linkconfig: {
        open: false,
        terrace: false,
        link: false,
        field: '',
        openConfig: 'original'
      },
      tableHeight: '100%',
      pageSizes: [25, 50, 100],
      detailOpenType: 'detail',
      countValue: 0,
      isCtrl: false,
      // 富文本控件是否只读
      isRichTextReadonly: true,
      tempRichAndDetailsName: '',
      tableWidth: '100%',
      isAddDetailKey: false,
      tempTableKey: [],
      customDetailValue: {},
      activeCol: { approvingId: '', title: '' }, // 列表页面的筛选字段
      tempBtnMenu: [],
      menuPosition: {},
      showMenu: false,
      tempMenuInfo: {},
      pageType: '',
      isAllAdd: false,
      addDataShow: false,
      coverVal: {},
      tempBtnBindingFun: '',
      showProgress: false,
    };
  },

  //--------------------------- 写代码麻烦写下备注，不然后期维护人员不知道如何开发-----------------------------------//
  computed: {
    getTableH() {
      if (this.isDoor) {
        if (this.listData && this.listData.data && this.listData.data.length !== 0 && this.isDoor ? this.tableStyleField.loadingMethod === 'pageCutting': this.listData && this.listData.total > 0) {
          return 'calc(100% - 10px)'
        } else {
          return '100%'
        }
      } else {
        return 'calc(100% - 60px)'
      }
    },
    isPivot() {
      return this.tableStyleField.filedType !== 'pivot'
    },
    getAllHeight(){
      let str = 'calc(100% - 50px)'
      const listData = this.listData
      const tableStyleField = this.tableStyleField
      const isDoor = this.isDoor
      if (isDoor) {
        if (listData && listData.data && listData.data.length !== 0 && isDoor ? tableStyleField.loadingMethod === 'pageCutting': listData && listData.total > 0) {
          str = 'calc(100% - 35px)'
        } else {
          str = '100%'
        }
      }
      return str
    },
    isNumFixed() {
      if (Array.isArray(this.tableKey)) {
        const flag = this.tableKey.some(item=>item.fixed)
        return flag
      } else {
        return false
      }
    },
    getTableHeight() {
      const ref = this.$refs.customRow
      let h = '100%'
      if (ref) {
        const el = ref.$el
        h = `calc(100% - ${el.getBoundingClientRect().height}px)`
      }
      return h
    },
    titleForRow() {
      const flag = this.clickEffect.titleForRow
      return flag
    },
    isFullHeight() {
     return !(this.listData && this.listData.data && this.listData.data.length !== 0 && this.isDoor ? this.tableStyleField.loadingMethod === 'pageCutting' : this.listData && this.listData.total > 0) 
    },
    isFixed() {
      return this.tableStyleField.tableWidth === 'fixed'
    },
    getMinWidth() {
      if (this.isDoor) {
        let w = this.tableStyleField.tableWidth === 'fixed' ? '14' : 170
        return w
      } else {
        return ''
      }
    },
    tableLine () {
      const { textLine, customLine } = this.tableStyleField
      const line = {
        '--line-': 1
      }
      if (textLine && textLine === 'custom') {
        line['--line-'] = customLine
      } else if (textLine) {
        line['--line-'] = textLine
      }
      return line
    },
    delValueColor () {
      const config = cloneDeep(this.listStyleConfig.valueConfig)
      delete config.color
      return config
    },
  },
  created () {
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    } else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
    }
  },
  methods: {
    tableMounted() {
      if (this.isDoor) {
        this.watchScrollToBootom()
      }
    },
    async swipeRet(val) {
      switch (this.tempBtnBindingFun) {
        case 'swipeAdd':
          {
            const payload = {type: 1,approvalId: this.approvalId}
            const upaceId = this.isUpace ? (this.$route.query.upaceid || localStorage.getItem('upaceid')) : undefined
            const flag = await isValidateapprovaltimeswitch(payload, upaceId)
            if (flag) return
            this.coverVal = val
            this.isAllAdd = false
            this.pageType = ''
            this.addDataShow = true
          }
        break
        case 'swipeUp':
          {
            let str = '/clientSide/application'
            const ob1 = {
              approvalId: this.approvalId,
              iId: 14,
              source: 'user',
              name: '',
              navShow: false,
              dataId: 14,
              search: JSON.stringify(val),
              swipe: true //刷卡后打开发起页标记
            }
            str += ('?' + qs.stringify(ob1))
            const obj = {
              approvalId: this.approvalId,
              datatype: 1,
              iId: 14,
              popUps: {
                customSize: 65,
                diaSize: '80%',
                h: 800,
                open: 2,
                w: 1700
              },
              search: str
            }
            this.$emit('openAppInitiate', obj)
          }
        break
      }
    },
    menuClose() {
      this.showMenu = false
      this.tempMenuInfo = {}
    },
    async handleMenuClick(item) {
      const bindingFunction = item.bindingFunction
      const { row } = this.tempMenuInfo
      this.tempBtnBindingFun = bindingFunction
      if (bindingFunction === 'edit') {
        this.tableUpdate(row, item)
      } else if (bindingFunction === 'todoinside') {
        // 站内应用
        item.pageType = item.pageType || ''
        this.$emit('todo-inside', { row, insideInfo: item.insideInfo })
      } else if (bindingFunction === 'todooutside') {
        // 外部链接
        this.$emit('todo-outside', { row, insideInfo: item.insideInfo })
      } else if (bindingFunction === 'del') {
        // 删除数据
        const idx = this.listData.data.findIndex(f=>f.approvingId === row.approvingId)
        this.deleteRow(1, idx)
      } else if (bindingFunction === 'dataLog-btn') {
        // 数据日志
        this.viewLogFun(row)
      } else if (bindingFunction === 'custom-scene') {
        // 自定义场景
        this.handleCustomScene(row, item)
      } else if (bindingFunction === 'blockchain') {
        // 区块链
        this.blockchainBtn(row)
      } else if (['app-comment', 'app-detail'].includes(bindingFunction)) {
        this.openDetailInfo([bindingFunction, item], row)
      } else if (bindingFunction === 'app-print') {
        this.appPrint(1, row)
      } else if (bindingFunction === 'report-print') {
        // 批量打印报表
      } else if (bindingFunction === 'app-report-print') {
        // 批量下载应用内报表
      } else if (bindingFunction === 'openAbility') {
        // 打开开发能力
      } else if (bindingFunction === 'to-nav') {
        this.$emit('to-nav', { row, insideInfo: item.toNavInfo })
      } else if (bindingFunction === 'dictionary') {
        this.openDictionary(row, item)
      } else if (bindingFunction === 'edit-user') {
        const info = item.editUser
        this.$emit('edit-user-info', info, row)
      } else if (['swipeAdd', 'swipeUp'].includes(bindingFunction)) {
        this.$refs.swipeIndexRef.open(item)
      }
    },
    async openDictionary(row, item) {
      let info = item.dictionaryInfo
      const par = {
        optionsId: info.optionsId
      }
      const res = await openapiGetoptions(par)
      if (res.code === 0) {
        info = res.data
        this.$emit('open-dictionary', info)
      } else {
        this.$message.error(res.msg)
      }
    },
    handleCustomScene(row, info) {
      const { open, popUps } = info.insideInfo
      const custom = info.customScene
      const skey = this.$route.query.skey || this.$route.params.skey
      const url = '/customInstrument'
      let paramsList = cloneDeep(custom.paramsList || [] )
      let paramsLists = []
      // 页面入参
      if (paramsList.length > 0) {
        let customData = []
        if (this.customData.length > 0) {
          customData = this.customData
        } else if (this.homeId) {
          // 当前页面的自定义参数
          customData = this.$store.state.doorCustomDataObj[this.homeId()] || []
        } else {
          customData = this.$store.state.doorCustomData
        }
        const obj = {
          paramsList: paramsList,
          customData,
          currentOrg: this.currentOrg,
          screen: this.screenRef,
          tableData: row
        }
        paramsLists = getParamsLists(obj)
      }
      const query = { showNav: false, name: custom.params, customDeskId: custom.id }
      if (skey) {
        query.skey = skey
      }
      if (paramsLists.length > 0) query.paramsList = JSON.stringify(paramsLists)
      if (open === 2 || open === 5) {
        // 弹窗
        this.$emit('custom-scene', {url:`${url}?${qs.stringify(query)}`,popUps, open, query})
      } else if (open === 3) {
        // 新窗口
        // window.open(`${url}?${qs.stringify(query)}`, '_blank')
        this.$openNewPage(url, query)
      } else if (open === 4) {
        // 当前窗口
        // window.location.replace(url);
        this.$router.push({ path: url, query })
      } else {
        this.$message.error('请选择打开方式')
      }
    },
    rowContextmenu(row, column, event) {
      if (!this.tableStyleField.isRightClickBtn) return
      event.preventDefault()
      const tempBtnMenu = this.tableTodoListComp({ row }, this.rightTodoList)
      this.tempBtnMenu = tempBtnMenu
      this.tempMenuInfo = {
        row,
        column,
        menuList: tempBtnMenu,
      }
      // 鼠标点击的原始坐标
      const mouseX = event.clientX;
      const mouseY = event.clientY;

      // 获取视口（Viewport）尺寸
      const viewportW = window.innerWidth || document.documentElement.clientWidth;
      const viewportH = window.innerHeight || document.documentElement.clientHeight;

      const menuW = 200; // 菜单在 CSS 中定义的宽度
      const menuH = 32 * tempBtnMenu.length; // 菜单的总高度 (假设有3个菜单项，每个30px，上下padding)
      let finalX = mouseX;
      let finalY = mouseY;

      // --- 垂直方向判断（Y轴） ---
      // 如果鼠标Y坐标 + 菜单高度 > 视口高度，说明菜单底部超出屏幕
      if (mouseY + menuH > viewportH) {
          // 将菜单向上移动，使其顶部对齐鼠标点击位置 (或略微向上移)
          // 调整到：鼠标Y坐标 - 菜单高度
          finalY = mouseY - menuH;

          // 进一步判断：如果向上移动后，顶部超出屏幕，则固定到屏幕顶部
          if (finalY < 0) {
              finalY = 0;
          }
      }

      // --- 水平方向判断（X轴） ---
      // 如果鼠标X坐标 + 菜单宽度 > 视口宽度，说明菜单右侧超出屏幕
      if (mouseX + menuW > viewportW) {
          // 将菜单向左移动，使其右侧对齐鼠标点击位置
          // 调整到：鼠标X坐标 - 菜单宽度
          finalX = mouseX - menuW;

          // 进一步判断：如果向左移动后，左侧超出屏幕，则固定到屏幕左侧
          if (finalX < 0) {
              finalX = 0;
          }
      }

      this.menuPosition = {
        x: finalX,
        y: finalY
      }
      this.showMenu = true
    },
    updateElTable() {
      this.uploadKey++
    },
    hideSecondLevelHeader ({ rowIndex }) {
      let str = 'row-header-style'
      if (this.pivotConfig && Array.isArray(this.pivotConfig.showLevel) && !this.pivotConfig.showLevel.includes(rowIndex + 1) && this.tableStyleField.filedType === 'pivot') {
        str += ' hidden-header'
      }
      return str
    },
    handleDetailCol(row, column, name){
      this.activeCol.title = name
      this.activeCol.approvingId = row.approvingId || row.approving_id
    },
    clearActiveCol(){
      this.activeCol.title = ''
      this.activeCol.approvingId = ''
    },
    getPlaceholder(val) {
      const column = this.showTodoList[val.title]
      if (column) {
        if (column.info && column.info.placeholder) {
          return column.info.placeholder
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    getCustomDetailValue(value) {
      if (Array.isArray(value)) {
        return value.map(item => item.name || item.realname).join(',')
      } else {
        return value
      }
    },
    changeDetailsCustom(val) {
      if (val.type.includes('_detailscustom')) {
        // 说明是展开 并且是自定义字段
        for (const ele of this.tableKey) {
          if (ele.isAppenFeild !== undefined) {
            // ele.isAppenFeild = false
            if (ele.filedInfo && ele.filedInfo.detailed && ele.type === 'details' && ele.filedInfo.detailed.displayEffect === 'horizontal') {
              this.$set(ele, 'isAppenFeild', true)
            } else {
              this.$set(ele, 'isAppenFeild', false)
            }
          }
        }
      } else if (val.filedInfo && val.filedInfo.detailed && val.type === 'details' && val.filedInfo.detailed.displayEffect === 'horizontal') {
        this.$set(val, 'isAppenFeild', false)
        for (const ele of this.tableKey) {
          if (ele.isAppenFeild !== undefined) {
            if (ele.type.includes('_detailscustom')) {
              this.$set(ele, 'isAppenFeild', true)
            }
          }
        }
      }
    },
    detailCustomClick(opt = {}) {
      const { value, e, row, parent, isParent = false, isTodo = false, isAncestor = false } = opt
      if (!isTodo) return
      const column = this.showTodoList[value.title]
      if (column) {
        if (column.type.includes('relation-user')) {
          this.$set(this, 'customDetailValue', { ...value, parent, approvingId: row.approvingId })
          this.curRow = row
          this.toGetValue({val: value.value, item: column, row})
        } else {
          let rect = {}
          let cell = e.target
          if (isParent) cell = e.target.parentNode
          if (isAncestor) cell = cell.parentNode.parentNode
          if (cell) {
            rect = cell.getBoundingClientRect()
          }
          if (this.tableStyleField.isTodoDiagle) {
            this.$refs.todoEdit.open({ row, column, rect, isCustomDetail: true, customDetailValue: { ...value, parent } })
          } else {
            this.$set(this, 'customDetailValue', { ...value, parent, approvingId: row.approvingId })
            this.$nextTick(() => {
              this.$refs.todoEditRef[0].open({ row, column, rect, isCustomDetail: true, customDetailValue: { ...value, parent } })
            })
          }
        }
      }
    },
    dealDetailData(list) {
      if (list.length === 0) return []
      const li = cloneDeep(list)
      let detailKey = ''
      let config = {}
      let details = {}
      let isFlag = false
      for (const ele of this.checkSyllable) {
        if (ele.type === 'details' && ele.filedInfo && ele.filedInfo.detailed && ele.filedInfo.detailed.displayEffect === 'horizontal') {
          detailKey = ele.title
          config = ele.filedInfo.detailed
          details = ele
          if (ele.filedInfo.detailed.defaultExpand === 'open') ele.isAppenFeild = false
          isFlag = true
        }
      }
      const { fieldName, fieldValue = [] } = config
      if (!this.isAddDetailKey) {
        const one = li[0]
        let detailData = cloneDeep(one[detailKey] || [])
        if (detailData && typeof detailData === 'string') detailData = JSON.parse(detailData)
        const tableKey = []
        detailData.pop()
        detailData.splice(20, detailData.length - 1)
        for (const key in detailData) {
          const ele = detailData[key]
          let name = ele[fieldName]
          if (name && Array.isArray(name)) {
            name = name.map(m => m.name || m.realname).join(',')
          }
          const obj = {
            title: `${fieldName.split('_')[0]}_${name}`,
            type: `${fieldName.split('_')[1]}_detailscustom`,
            name,
            isCustomDetail: true,
            parentDetail: detailKey,
            w: details.w,
            percentageW: details.percentageW,
            customKey: Number(key)
          }
          if (isFlag) {
            obj.isAppenFeild = details.filedInfo.detailed.defaultExpand !== 'close'
          }
          // eslint-disable-next-line vue/no-mutating-props
          this.checkSyllable.push(obj)
          tableKey.push(obj)
        }
        this.tempTableKey = tableKey
      }
      if (detailKey) {
        for (const ele of li) {
          let detailData = cloneDeep(ele[detailKey] || [])
          if (detailData && typeof detailData === 'string') detailData = JSON.parse(detailData)
          detailData.pop()
          for (const detail of detailData) {
            const data = []
            for (const field of fieldValue) {
              const value = detail[field]
              const obj = {
                title: field.split('_')[0],
                type: field.split('_')[1],
                value
              }
              data.push(obj)
            }
            let name = detail[fieldName]
            if (name && Array.isArray(name)) name = name.map(m => m.name || m.realname).join(',')
            ele[`${fieldName.split('_')[0]}_${name}`] = data
          }
        }
      }
      this.isAddDetailKey = true
      return li
    },
    async todoChange(opt) {
      const { row, column, value } = opt
      const obj = {
        approvalId: this.approvalId,
        approvingId: row.approvingId,
        feild: `${column.title}_${column.type}`,
        value
      }
      const flag = await this.updateAppField(obj)
      this.todoReset(row)
      if (flag) {
        const i = this.listData.data.find(f=> f.approvingId === row.approvingId)
        if (i) {
          i[column.title] = value
        }
      }
    },
    async todoReset(row) {
      console.log(row, "todoReset")
      this.customDetailValue = {}
      this.curRow = {}
    },
    async openDetailControl(opt = {}) {
      const { filed, isReadonly = true, row } = opt
      const value = cloneDeep(row[filed.title])
      if (!isReadonly) {
        const param = {
          key: 2,
          data: row,
        }
        this.detailOpenType = 'detail'
        this.$emit("sourceAudit", param, filed)
        return
      }
      let property = this.approvalInfo.property
      if (property) {
        property = typeof property === 'string' ? JSON.parse(property) : property
      } else {
        const __par = { approvalId: this.approvalId }
        if (this.isUpace) {
          let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
          __par.upaceid = upaceId
        }
        const { code, data } = await openapiGetapproval(__par)
        if (code === 0) property = typeof data.property === 'string' ? JSON.parse(data.property) : data.property
        else return this.$message.error('获取配置失败')
      }
      const control = property.find(f=>f.title === filed.title)
      const formdata = typeof value === 'string' ? JSON.parse(value) : value
      // 不知道为什么明细这个数据格式有问题 有些时候第一条是数据有些时候第一条又是不要的数据
      // formdata.pop()
      const fileControl = control.list.find(f=> f.type === 'file')
      if (fileControl) {
        for (const ele of formdata) {
          const file = ele[`${fileControl.title}_${fileControl.type}`]
          if (file && file.length > 0) {
            let newFiled = file.map(f=>{
              let name = f.response ? f.response.split('/')[f.response.split('/').length - 1] : ''
              name = name.split('-')[name.split('-').length - 1]
              return {
                ...f,
                url: this.$imgurl + f.response,
                name
              }
            })
            ele[`${fileControl.title}_${fileControl.type}`] = newFiled
          }
        }
      }
      // 将明细控件改为只读
      control.per = 2
      control.list.forEach(item=> {
        item.per = 2
      })
      if (filed.filedInfo && filed.filedInfo.detailed && filed.filedInfo.detailed.fieldAppen && filed.filedInfo.detailed.fieldAppen.length > 0) {
        control.list = control.list.filter(f=> filed.filedInfo.detailed.fieldAppen.includes(`${f.title}_${f.type}`))
      }
      this.$refs.detailReadonly.open({
        formdata,
        control,
      })
    },
    openRichAndDetails(row, val) {
      if (val.type === 'details') {
        this.openDetailControl({ row: row, filed: val, isReadonly: !(this.tableStyleField.isTodoList && this.showTodoList[val.title]) })
      } else {
        if (this.tableStyleField.isTodoList && this.showTodoList[val.title]) {
          // 列表编辑
          this.goTodoEdit({ row, column: { property: val.title, label: val.type }, interactive: this.showTodoList[val.title].info.interactive})
        } else {
          // 列表查看
          const control = this.checkSyllable.find(item=> item.title === val.title)
          this.openRichText({ value: row[val.title], disabled: true, title: control && control.name })
        }
      }
    },
    openRichText(opt) {
      const { value, disabled = false, title = '' } = opt
      const bindinf = value
      this.isRichTextReadonly = disabled
      this.tempRichAndDetailsName = title
      this.$refs.richTextEdit.open({ bindinf })
    },
    async richTextEditCallBack(val) {
      const value = val.formData
      const row = this.curRow
      const item = this.curClickTitleType
      const obj = {
        approvalId: this.approvalId,
        approvingId: row.approvingId,
        feild: `${item.title}_${item.type}`,
        value
      }
      const flag = await this.updateAppField(obj)
      if (flag) {
        const i = this.listData.data.find(f=>f.approvingId === row.approvingId)
        if (i) {
          i[item.title] = value
        }
      }
      this.curRow = {}
      this.curValue = null
      this.isEditTodo = false
      this.curClickTitleType = { title:'', type:'' }
      this.$emit('resetRefresh')
    },
    // 获取表格键值
    getTableKey(val) {
      // 如果val的长度为0，则返回
      if (val.length === 0) return
      // 将val赋值给this.tableKey
      if (val.length > 50) {
          this.tableKey = val.slice(0, 50)
          // requestAnimationFrame(this.setTableKey)
      } else {
          this.tableKey = val
      }
    },
    // 设置表格键值
    setTableKey() {
      // 如果this.tableKey的长度等于this.checkSyllable的长度，则返回
      if (this.tableKey.length === this.checkSyllable.length) return
      // 定义一个数组，用于存储任务
      const tasts = []
      // 定义一个变量，用于存储this.tableKey的长度
      let count = this.tableKey.length
      // 定义一个变量，用于存储this.checkSyllable从count到this.checkSyllable.length的切片
      const li = this.checkSyllable.slice(count, this.checkSyllable.length)
      // 如果li的长度大于0，则遍历li
      if (li.length > 0) {
          li.forEach((item) => {
              // 定义一个函数，用于将item添加到this.tableKey中
              const fn = () => {
                  this.tableKey.push(item)
              }
              // 将函数添加到tasts中
              tasts.push(fn)
          })
      }
      // 执行任务
      performTakss(tasts)
    },
    upCheckbox ({val, item, row, title}) {
      row[title] = val
      this.changeRadioValue({val: val, item: item, row: row}, true)
    },
    getRowStyle({ row }) {
      let color = ''
      const scope = { row }
      for (const ele of this.tableKey) {
        const val = this.getValue(scope, ele)
        if (!ele.filedInfo) continue
        if (!ele.filedInfo.isColor) continue
        const colorType = ele.filedInfo.colorType
        const list = ele.filedInfo.list
        const styleInfo = getLabelColor({options:list}, val, undefined, colorType)
        if (colorType === '3') {
          color = styleInfo.color
        }
      }
      if (this.listStyleConfig.valueConfig && this.listStyleConfig.valueConfig.color && !color) color = this.listStyleConfig.valueConfig.color
      return { height: '22px', cursor: this.clickEffect.effect === 'notodo' ? 'default' : 'pointer', '--color-row': color }
    },
    appPrint(val, row){
      // 正常来说是没有id的 有id的话 直接不要
      if (val) return
      this.$emit('appPrint', row)
    },
    openLinkText (val) {
      console.log('ssss', val)
      window.open(val)
    },
    goReload() {
      this.$emit('resetRefresh')
    },
    getTimeLabels (val, scope) {
      if (!val || !scope) return ''
      if (val.type === 'date' && scope.row[val.title] && val.timeList && val.timeList.open && val.timeList.options && val.timeList.options.length > 0) {
          const label = this.getTimeLabel(scope.row[val.title], val.timeList.options)
          return label
      }
      let value = this.getResValue(this.getValue(scope, val), val) || (this.showTodoList[val.title] && this.showTodoList[val.title].placeholder)
      if (value && value.includes('1970-01-01')) {
        try {
          value = value.split(' ')[1].split(':').slice(0, 2).join(':')
        } catch (err) { console.log(err) }
      }
      return value
    },
    getWeek (val) {
      return getWeek(val)
    },
    getArchive (row) {
      const archive = typeof row.archive === 'undefined' ? 0 : row.archive
      const obj = {
        0: '未归档',
        1: '已归档'
      }
      return obj[archive]
    },
    getConfigCenter (type = 'left') {
      const obj = {
        left: 'flex-start',
        center: 'center',
        right: 'flex-end'
      }
      return obj[type]
    },
    isDelAndEdit(row, type = 'delete') {
      const obj = {
        delete: 'manualDoNotDel',
        update: 'manualDoNotModify' 
      }
      let isAppen = this.widgetDataObj[type] && row.archive && row[obj[type]]
      isAppen = typeof isAppen === 'string' ? JSON.parse(isAppen) : isAppen
      if (this.widgetDataObj[type] && !row.archive) {
        return true
      } else if (isAppen) {
        return false
      } else {
        return this.widgetDataObj[type]
      }
    },
    async orgChoiceMethod(resUser) {
      const title = this.curClickTitleType.title
      const row = this.curRow
      let valArr = [];
      // 联系人控件
      if(Object.property.hasOwnProperty.call(resUser, 'checkedUserArr')){
        resUser.checkedUserArr.forEach(el => {
          let elObj = {
            realname: el.realname,
            userId: el.userId
          };
          // 如果有组织信息
          if (el.orgname) elObj.orgname = el.orgname
          valArr.push(elObj);
        });
      } else if (Object.property.hasOwnProperty.call(resUser, 'checkedFlowArr')) {
        resUser.checkedFlowArr.forEach(el => {
          let elObj = {
            name: el.name,
            organizationId: el.organizationId,
            looktype: el.looktype || 0,
            type: el.type
          };
          valArr.push(elObj);
        });
      } else if (Object.property.hasOwnProperty.call(resUser, 'checkedRoleArr')) {
        resUser.checkedRoleArr.forEach(el => {
          let elObj = {
            name: el.name,
            roleId: el.roleId
          };
          valArr.push(elObj);
        });
      }
      if (Object.keys(this.customDetailValue).length > 0) {
        let details = this.curRow[this.customDetailValue.parent.parentDetail]
        const [title, option] = this.customDetailValue.parent.title.split('_')
        const [type] = this.customDetailValue.parent.type.split('_')
        details = typeof details === 'string' ? JSON.parse(details) : details
        for (const ele of details) {
          if (ele[`${title}_${type}`] === option) {
            ele[`${this.customDetailValue.title}_${this.customDetailValue.type}`] = valArr
          }
        }
        this.curRow[this.customDetailValue.parent.parentDetail] = JSON.stringify(details)
        for (const ele of this.curRow[this.customDetailValue.parent.title]) {
          if (ele.title === this.customDetailValue.title) {
            ele.value = valArr
            break
          }
        }
        this.todoChange({ row: this.curRow, column: { title: this.customDetailValue.parent.parentDetail, type: 'details' }, value: JSON.stringify(details) })
        this.todoReset()
      } else {
        row[title] = valArr
        this.curValue = valArr
        this.isEditTodo = true
        this.resetListEditTodo()
      }
    },
    fromMultipleChoice(val) {
      this.orgChoiceMethod(val)
    },
    enterCheck(opt = {}) {
      const { val } = opt
      if (opt.item.type === 'textarea') {
        if (!val.ctrlKey && !val.shiftKey) {
          val.preventDefault()
          this.changeValue(opt)
          this.resetListEditTodo()
        }
      } else {
        this.changeValue(opt)
        this.resetListEditTodo()
      }
    },
    controlEnterCheck(opt = {}) {
      const { val, item, row } = opt
      if (item.type === 'textarea') {
        let value = row[item.title]
        val.preventDefault();
        // 获取当前光标位置
        const start = val.target.selectionStart
        const end = val.target.selectionEnd
        // 在光标位置插入换行符
        row[item.title] = value.substring(0, start) + '\n' + value.substring(end)
        // 移动光标到插入的换行符后
        this.$nextTick(() => {
          val.target.selectionStart = val.target.selectionEnd = start + 1
        })
      }
    },
    toGetValue(opt) {
      let { item, row } = opt
      
      let data = cloneDeep(item)
      let val = row[data.title]
      if (val) {
        val = typeof val === 'string' ? JSON.parse(val) : val
      }
      // if (value && Object.keys(value).length !== 0) {
      //   val = value
      // }
      const _info = {
        id: this.approvalId,
        info: val,
        data
      }
      const param = getUserParam(_info)
      // 选择角色控件，并且角色查看范围设置位全部角色（调用平台角色+空间角色弹窗）
      if(data.type == 'roule' && data.lookRMSIsUserRole == 2){
        delete param.onlyUser
        param.curHigh = this.isSpace ? 3 : 1
        this.$refs.allMultipleChoiceRef.multipleChoiceMethod(param);
        this.isMultipleChoice = true;
      } else{
        this.$refs.multipleChoiceRef.multipleChoiceMethod(param);
        this.isMultipleChoice = true;
      }      
    },
    delUpload(idx,val,row,item) {
      val.splice(idx, 1)
      row[item.title] = val
      this.curValue = JSON.stringify(val)
      this.isEditTodo = true 
    },
    uploadSuccess(file, val, row, item) {
      const response = filesConfig(file)
      if (!response) return
      val.push({response})
      row[item.title] = val
      this.curValue = JSON.stringify(val)
      this.isEditTodo = true
      this.showProgress = false
    },
    beforeImgUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error("上传图片只能是 jpeg/png/gif 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return (isJPG && isLt2M) || (isPNG && isLt2M) || (isGIF && isLt2M);
    },
    onProgress() {
      this.showProgress = true
    },
    beforeFileUpload(file, item) {
      // 限制上传
      const isLt2M = file.size / 1024 / 1024 < Number(item.maxSize);
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 5MB!");
      }
      return isLt2M
    },
    // 不包含本日的时间返回可选的开始时间
    nextMonthFun(val) {
      return thisNoTime(val);
    },
    // 时间限制
    pickerOptionsLimit(val) {
      if (this.modifyId) return "";
      let date = val.dayWeek;
      if (
        !val.dayWeek &&
        (val.limit === "week" ||
          val.limit === "nextWeek" ||
          val.limit === "dayWeek")
      )
      date = 7;
      return limitDate(val.limit || "", date);
    },
    async goTodoEdit(opt = {}) {
      const { row, column, interactive = 'doubleClick', cell, event } = opt
      // 双击编辑
      if (!this.isDoor || this.curRow.isEditTodo) return
      if (!this.tableStyleField.isTodoList) return
      const noTodoDialogType = ['relation-user', 'richTextWid','details']
      let colProperty = column.property
      if (colProperty && colProperty.includes('_')) {
        return
      }
      if (this.tableStyleField.isTodoDiagle && !noTodoDialogType.includes(column.label)) {
        // 打开弹窗编辑
        // const idx = column.
        let rect = {}
        if (cell) {
          rect = cell.getBoundingClientRect()
        } else if(event){
          const cellElement = event.currentTarget.closest('.el-table__cell')
          if (cellElement) {
            rect = cellElement.getBoundingClientRect()
          }
        }
        if (!this.showTodoList[colProperty]) return
        this.$refs.todoEdit.open({ row, column: this.showTodoList[colProperty], rect })
        return
      }
      const title = colProperty
      const type = column.label
      const config = this.showTodoList[title]
      if (type === 'details') {
        const filedInfo = this.checkSyllable.find(item=>item.title === title)
        this.openDetailControl({ row, filed: filedInfo, isReadonly: false })
        return
      }
      if (config === undefined) return
      if (config.info.interactive !== interactive) return
      if (this.curRow && this.curRow.isEditTodo && interactive === 'buttonClick') {
        // 点击事件 由于是组件点击，所以没有冒泡需要在这边判断一下， 上次的编辑有没有结束
        this.resetListEditTodo()
      }

      if (type === 'radio' || type === 'checkbox') {
        const flag = await this.getRadioList({ title })
        if (flag && this.showTodoList[title] && Array.isArray(flag) && flag.length !== 0) {
          this.showTodoList[title].sels = flag
        }
      }
      
      row.isEditTodo = true
      this.curClickTitleType = {
        type,
        title
      }
      this.curValue = row[title]
      this.curRow = row
      if (type === 'richTextWid') { 
        this.openRichText({value: row[title], disabled: false, title: config.name })
      }
      this.$nextTick(() => {
        if (['relation-user','organization','roule'].indexOf(type) !== -1) {
          this.toGetValue({val: {}, item: this.showTodoList[title], row})
        }
        if (this.$refs.textInp && this.$refs.textInp[0]) {
          this.$refs.textInp[0].focus()
        }
        if (this.$refs.todoSelect && this.$refs.todoSelect[0]) {
          this.$refs.todoSelect[0].toggleMenu()
        }
        if (this.$refs.todoDate && this.$refs.todoDate[0]) {
          this.$refs.todoDate[0].showPicker()
        }
      })
    },
    
    async resetListEditTodo(e) {
      // 判断点击外面是否要变化状态
      if (!this.isEditTodo) {
        this.curRow.isEditTodo = false
        return
      }
      
      // 这里去请求接口
      const row = this.curRow
      let value = this.curValue
      const item = this.curClickTitleType
      const cur = this.showTodoList[item.title]
      if (JSON.stringify(this.curRow) === '{}' || value === null) return
      // 由于这三个组件是打开弹窗的，所以需要在这边判断一下，防止走了两次接口
      if (['relation-user', 'organization', 'roule'].includes(this.curClickTitleType.type) && e) return
      if (cur && cur.required && cur.required === 'required') {
        // 判断是否必填
        const isArr = this.todoIcon[item.type]
        if ((isArr && Array.isArray(value) && value.length === 0) || !value) {
          // 说明是组织控件,角色控件,联系人控件 可能为空数组
          this.$message.error(`${cur.name}不能为空`)
          return
        }
      }

      // 判断格式是否正确 
      if (item.type === 'text' && cur) {
        if (cur.idCardValid) {
          const idCardReg = /^(1[1-5]|2[1-3]|3[1-7]|4[1-6]|5[0-4]|6[1-5]|71|8[1-2])\d{4}(19\d{2}|20[01]\d)(0[1-9]|1[0-2])(0[1-9]|[1-2]\d|3[01])\d{3}[0-9xX]$/  
          if (!idCardReg.test(value)) {
            this.$message.error(`${cur.name}不能为空`)
            return
          }
        }
        if (cur.regularObj.val && cur.regularObj.setting && cur.regularObj.setting.region === 1 && cur.regularObj.setting.rulesVal === 1) {
          const phoneReg = /^1[3456789]\d{9}$/
          if (!phoneReg.test(value)) {
            this.$message.error(`${cur.name}不能为空`)
            return
          }
        }
      }
      if (cur && cur.match === 'HH:mm' && item.type === 'date') {
        value = `1970-01-01 ${value}:00`
      }
      this.curRow.isEditTodo = false
      const obj = {
        approvalId: this.approvalId,
        approvingId: row.approvingId,
        feild: `${item.title}_${item.type}`,
        value
      }
      await this.updateAppField(obj)
      this.curRow = {}
      this.curValue = null
      this.isEditTodo = false
      this.curClickTitleType = { title:'', type:'' }
    },
    async updateAppField(obj) {
      const res = await updateapprovingbyfeild(obj)
      if (res.code === 0) {
        this.$message.success('修改成功')
        return true
      } else {
        this.$message.error(res.msg)
      }
    },
    getSwitchColor (opt = {}) {
      return getSwitchColor(opt)
    },
    changeRadioValue(opt = {}, type = 'radio') {
      // 单选控件单独写
      let { val, item = {}, row } = opt
      if (!row.approvingId) return
      // 判断是否必填和是否规则
      row[item.title] = val
      const obj = {
        approvalId: this.approvalId,
        approvingId: row.approvingId,
        feild: `${item.title}_${item.type}`,
        value: val
      }
      if (type === 'other') {
        this.curValue = val
        this.isEditTodo = true
        this.resetListEditTodo()
      } else {
        this.updateAppField(obj)
      }
    },
    async changeValue (opt = {}) {
      let { val, item = {}, row } = opt
      // 由于显示值 和 提交值不一样  在这边要做一下处理
      if (item.type === 'text' || item.type === 'textarea' || item.type === 'number') {
        if (val && val.target) {
          val = val.target.value
        }
      } else if (item.type === 'new-rel-radio') {
        val = val['自定义标题'] 
      } else if (item.type === 'date' && item.match === 'HH:mm' && val === '') {
        return
      }
      if (item.type === 'number') {
        if (Number(row[item.title]) === val) return
      } else if(item.type === 'date' && item.match === 'HH:mm'){
        // TODO
      } else {
        if (row[item.title] === val) return
      }
      // 如果说值没有变化  不需要请求接口
      if (val === null) val = ''
      row[item.title] = val
      this.curValue = val
      this.isEditTodo = true
      if (item.type === 'date' || item.type === 'radio') {
        this.resetListEditTodo()
      }
    },
    wyNumChangeValue (opt = {}) {
      opt.val = opt.val * 10000
      this.changeValue(opt)
    },
    async handleTodoConfig () {
      this.$nextTick(() => {
        document.addEventListener('click', this.resetListEditTodo)
      })
      const showTodoList = {}
      for (const item of this.listTodoConfig) {
        if (item.detailsTodoLi && item.type === 'details') {
          for (const ele of item.detailsTodoLi) {
            if (ele) {
              const [ title ] = ele.split('_')
              const cur = item.list.find(e => e.title === title)
              if (cur) {
                cur.info = item.info
                showTodoList[title] = cur
              }
            } else {
              showTodoList[item.title] = item
            }
          }
        } else {
          showTodoList[item.title] = item
        }
      }
      // this.showTodoList = Object.freeze(showTodoList)
      this.$set(this, 'showTodoList', Object.freeze(showTodoList))
    },
    async getRadioList(item){
      const param = {
        approvalId: this.$route.query.approvalId || this.approvalId,
        feild: item.title
      }
      let list = []
      const res = await axiosBase(param, 'api/getradiodata')
      if (res.code === 0) {
        list = res.data
      } else {
        return false
      }
      return list
    },
    objSels (item) {
      if (typeof (item) === 'string') {
        return JSON.parse(item)
      } else {
        return item
      }
    },
    getLabelColor(item, value, colorType) {
      const obj = getLabelColor(item,value, undefined, colorType)
      if (colorType === '3') {
        return {}
      } else {
        delete obj.display
        obj.width = 'fit-content'
        return obj
      }
    },
    getValue(scope, val) {
      return val.type === 'radio' && val.sels ? this.getRadioLabel(this.strData(scope.row[val.title], val.encrypt), val.sels) : this.strData(scope.row[val.title], val.encrypt)
    },
    labelColor (val, filed) {
      if (!filed.filedInfo) return
      if (!filed.filedInfo.isColor) return
      const list = filed.filedInfo.list
      const obj = this.getLabelColor({options:list}, val, filed.filedInfo.colorType || '1')
      obj.padding = '2px 12px'
      obj.lineHeight = `${parseInt(this.tableStyleField.listLineHeight || '32px') - 8}px`
      return obj
    },
    getResValue (val, filed, scope = {}) {
      let str = val
      if (val === 0 && filed.type === 'number') return 'zero' // 返回特殊标识
      if (val !== 0 && !val) return ''
      if (filed.type === 'date' || filed.title === '提交时间') {
        str = getDateValue(val, filed, scope.row)
      } else if (filed.type === 'number') {
        str = getNumValue(val, filed)
      } else if (filed.type === 'text') {
        str = getTextValue(val, filed)
      }
      return str
    },
    numFormatStyle (val, filed) {
      if (filed.type !== 'number') return
      if (filed && filed.filedInfo && filed.filedInfo.configNumber && filed.filedInfo.configNumber.markedRed && Number(val) < 0) {
        return {
          color: '#ff0000'
        }
      }
    },
    showFiledName (filed) {
      let name = ''
      if (filed.filedInfo && filed.filedInfo.name) {
        name = filed.ctitle || filed.filedInfo.name
        const res = dealText({
          text: name,
          commonData: this.$store.state.userData,
          customData: this.$store.state.doorCustomData,
          functionParms: filed.filedInfo.functionParms || []
        })
        if (res) name = res
      } else {
        name = filed.name
      }
      return name
    },
    indexMethods(idx) {
      const { currentPage, tablePageSize  } = this.listInfo
      return tablePageSize * (currentPage - 1) + (idx + 1)
    },
    // 保留两位小数
    toDecimal(num) {
      if (typeof num === 'string') {
        const number = num.split('.').length > 1 ? Number(num).toFixed(2) : num
        return +number
      }
      return num
    },
    getNumberVal (num) {
       return num / 10000
    },
    isWYFN (val) {
      return isWY(val)
    },
    isJSON(val) {
      return isJSON(val)
    },
    filesConfig() {
      return filesConfig()
    },
    isArrAndNoLen(val) {
      return Array.isArray(val) && val.length !== 0
    },
    strImgAndFileData(val) {
      if (!val) return ''
      let filename = ''
      if (typeof val === 'object') {
        filename = val.realname || val.response || ''
      } else {
        filename = val
      }
      if (!filename) return ''
      try {
        const mps = filename.split('/')
        const mp = mps[mps.length - 1]
        const str = mp.split('-')[1]
        return str || filename
      } catch (err) {
        return filename
      }
    },
    goPreview (val, down) {
      filePreview(val, down)
    },
    // 获取文件类型
    getFileFormat (name) {
      if (!name) return false
      let site = name.lastIndexOf("\\.");
      let format =  name.substring(site + 1, name.length);
      format = format.toLocaleLowerCase()
      const formatList = ['mp3', 'mp4', 'aac', 'mp4', 'wmv', 'avi', 'flv']
      return formatList.includes(format)
    },
    // 播放音乐
    async playFun (val) {
      const name = val.response
      let site = name.lastIndexOf("\\.");
      let format =  name.substring(site + 1, name.length);
      format = format.toLocaleLowerCase()
      const url = this.$url + val.response
      const videoList = ['mp4', 'wmv', 'avi', 'flv']
      if (videoList.includes(format)) {
        this.$videoPlayer().paly(url)
      } else {
        this.$musicPlayer().paly(url)
      }
    },
    goOpenOver(item) {
      if (item.isOpen === undefined) {
        const tableKey = JSON.parse(JSON.stringify(this.tableKey))
        tableKey.forEach(c => {
          if (c.title === item.title) {
            c.isOpen = true
          } else {
            c.isOpen = false
          }
        })
        this.tableKey = tableKey
        return
      }
      const opt = item.isOpen
      this.tableKey.forEach(c => {
        c.isOpen = false
      })
      item.isOpen = !opt
    },
    getImageView (val) {
      if (!val) return []
      try {
        val = uploaderFun(val, 'image')
      } catch (e) {
        return []
      }
      return val
    },
    getRelCheck (item) {
      try {
        if (typeof item === 'object') {
          return item.top && item.data && item.data.length > 0 ? item : false
        } else {
          return JSON.parse(item)
        }
      } catch (e) {
        console.log(e)
        return false
      }
    },
    getRadioLabel (val, item) {
      if (!item || item.length === 0) return val
      for (const i of item) {
        if (i.value === val) return i.label
      }
      return val
    },
    // 查询控件查询
    async queryData(rowData, val){
      let that = this
      let ele = val
      that.approvingId = rowData.approvingId
      axiosBase(
        { 
          approvalId: that.$route.query.approvalId || that.approvalId,
          approvingId: that.approvingId,
          feild: val.title + '_' + val.type
        },
        "/openapi/getsearchbuttoninfo"
      ).then(async (res) => {
        if (res.code === 0) {
          let param = linkedSetEvent(res.data.dataconfig, JSON.parse(res.data.data), {
            types: false
          });
          ele.dataconfig = res.data.dataconfig
          if (param) {
            let x = await that.awaitGetlinkeddatalist(param)
            that.linkeddataResult(ele, x)
          }
        }
      });
    },
    awaitGetlinkeddatalist(pargam) {
      const that = this
      return new Promise(function(resolve) {
				// console.log('添加approvalId和approvingId',this.approvalId,this.approvingId)
				pargam.approvalId = that.$route.query.approvalId || that.approvalId
        pargam.approvingId = that.approvingId
        // 从空间进入，需要传空间id
        if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
          pargam.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
        }    
        getlinkeddatalist(pargam).then(res => {
          resolve(res.data);
        });
      });
    },
    //- 联动后返回需要加入formdata关联一级控件或者明细控件的数据
    linkeddataResult(item, res) {
      console.log('返回联动', item, res)
      let that = this
      let resultVal
      const listData = that.listData.data
        //- 控件后台给的数据错误少了一个层级
        if (res !== null) {
          // 填充查询
          if (item.dataconfig && item.dataconfig.setUpValue === 1) {
            resultVal = res[0]
          }
          // 点击查询
          else{
            resultVal = res;
          }
          for(let i = 0; i < listData.length; i++){
            if(listData[i].approvingId === that.approvingId){
              listData[i][item.title] = resultVal
              console.log("listData",listData)
              break;
            }
          }
          that.listData.data = listData
      }
    },
    async openPrint(payload, rowData) {
      const printConfig = payload.printConfig
      this.ruleList = payload.ruleList
      this.printBoxOpen = true
      // 处理一下本表数据
      this.printFormdata = await this.getFromdata(rowData, payload.approvalId)
      this.printTitle = printConfig.canvasName
      // 兼容一下旧配置
      this.printBoxConfig = JSON.parse(JSON.stringify(this.compatibleSheetCongfig(printConfig)))
      // 判断是否有他表的数据
      if (printConfig.dataSource.formList && printConfig.dataSource.formList.length>0) {
        let spaceId, upaceId
        if (this.isSpace) {
          spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        }
        else if (this.isUpace) {
          upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        }
        const { otherData } = await DealPrintData.getOtherApproval(printConfig, this.printFormdata, spaceId, upaceId)
        if (otherData.deptGroup !== undefined) {
          this.deptGroup = JSON.parse(JSON.stringify(otherData.deptGroup))
          delete otherData.deptGroup
        } else {
          this.deptGroup = {}
        }
        this.printFormdata = { ...this.printFormdata, ...otherData }
      }
      // 获取一下联系人其他的数据和单选存储值的兼容
      this.printFormdata = await DealPrintData.getRelationUserInfo(JSON.parse(JSON.stringify(this.printFormdata)))
      this.printFormdata = await DealPrintData.dealRadioLabel(JSON.parse(JSON.stringify(this.printFormdata)), this.ruleList)
      this.printBoxShow = true
    },
    compatibleSheetCongfig (config) {
      let resultConfig = JSON.parse(JSON.stringify(config))

      if (resultConfig.sheetList.length > 0 && resultConfig.sheetList[0].sheets && resultConfig.sheetList[0].sheets.length > 0) {
        const sheetList = resultConfig.sheetList[0].sheets
        // 删除原来配置的 工作表
        delete resultConfig.sheetList[0].sheets
        // 旧的全局配置
        const sheetOldConfig = JSON.parse(JSON.stringify(resultConfig.sheetList[0]))
        sheetList.forEach(item => {
          // 将原来的全局配置分配给每个工作表
          if (resultConfig.sheetConfig === undefined) resultConfig.sheetConfig = {}
          resultConfig.sheetConfig[item.index] = {...sheetOldConfig}
        })
        resultConfig.sheetList = sheetList
      }
      return resultConfig
    },
    // 处理一下本表数据
    async getFromdata(rowData, approvalId) {
      let res = {}
      const query = {
        curpage: 0,
        pagesize: 0,
        approvingId: rowData.approvingId,
        approvalId
      }
      // 请求本表的数据
      const {data, code} = await getuserapprovinglist(query)
      if (code === 0) {
        res = JSON.parse(data[0].approving.formdata)
        // 获取默认的字段
        const defaultKey = {}
        const defaultKeyList = ['申请人_relation-user', '单号_text', '状态_status', '提交时间_date', '归档状态_status']
        defaultKeyList.forEach(item => {
          defaultKey[item] = DealPrintData.handleDefaultKey(item, data[0])
        })
        res = { ...res, ...defaultKey }
      }
      return res
    },
    getTodoWidth() {
      const ref = this.$refs.tableBox
      if(!ref) return
      const tableTodoList = ref.$el.querySelectorAll('.table-todo')
      if (!tableTodoList) return
      // 最大的长度
      let signMax = 0
      // 最大的长度的索引
      let signIdx = 0
      tableTodoList.forEach((item,idx) => {
        const list = item.querySelectorAll('.table-todo-item')
        if (list && signMax < list.length) {
          signMax = list.length
          signIdx = idx
        }
      })
      this.todoWidth = (signMax - 1) * 8 + 20
      if (!tableTodoList[signIdx]) {
        if (this.todoWidth < 60) {
          this.todoWidth = 60
        }
        return
      }
      const todo = tableTodoList[signIdx].querySelectorAll('.table-todo-item')
      todo.forEach(item => {
        this.todoWidth += item.getBoundingClientRect().width
      })
      // 如果配置了文件解析
      if(this.listData.data.length > 0 && Object.prototype.hasOwnProperty.call(this.listData.data[0], 'transfile')){
        this.todoWidth += 32
      }
      if (todo.length === 0 || this.todoWidth < 60) {
        this.todoWidth = 60
      }
    },
    qrcodeBtn(value, row) {
      let obj = {}
      if (value === 'minstatic') {
        obj = { channel: 'mini', type: 1, approvingId: row.approvingId, customTitle: row['自定义标题'], approvalId: this.approvalId, }
      } else if (value === 'mindynamic') {
        obj = { channel: 'mini', type: 2, approvingId: row.approvingId, customTitle: row['自定义标题'], approvalId: this.approvalId, }
      } else if (value === 'h5static') {
        obj = { channel: 'h5', type: 1, approvingId: row.approvingId, customTitle: row['自定义标题'], approvalId: this.approvalId, }
      } else if (value === 'h5dynamic') {
        obj = { channel: 'h5', type: 2, approvingId: row.approvingId, customTitle: row['自定义标题'], approvalId: this.approvalId, }
      } else if (value === 'lookministatic') {
        obj = {
          channel: 'mini',
          type: 1,
          mode: 'look', // 用来判断是不是查看的二维码
          approvingId: row.approvingId,
          customTitle: row['自定义标题'],
          approvalId: this.approvalId,
          userApprovingId: row.userApprovingId
        }
      } else if (value === 'lookh5static') {
        obj = {
          channel: 'h5',
          type: 1,
          mode: 'look', // 用来判断是不是查看的二维码
          approvingId: row.approvingId,
          customTitle: row['自定义标题'],
          approvalId: this.approvalId,
          userApprovingId: row.userApprovingId
        }
      }
      this.onQrcodeCommand(obj)
    },
    blockchainBtn() { },
    tableTodoListComp(scope, li) {
      if (Object.keys(this.widgetDataObj).length === 0) return []
      const log = this.pageId === '7' || this.pageId === '6' ? 'oplog' : 'myoplog'
      if (!li) li = this.tableTodoList
      let arr = li.filter(item => {
        // 一个一个去判断按钮是否显示
        let isAppen = true
        if(item.conditionAppen && Object.keys(item.conditionAppen).length > 0){
          const customData = this.$store.state.doorCustomDataObj[this.customDeskId] || undefined
          isAppen = isConditionAppen(item.conditionAppen, scope.row, true, customData)
        }
        if (item.id === 1 && this.widgetDataObj.update && item.isShow) {
          // 编辑
          return isAppen
        } else if (item.id === 2 && this.widgetDataObj.delete && item.isShow) {
          // 删除
          return isAppen
        } else if (item.id === 3 && this.widgetDataObj[log] && item.isShow) {
          // 数据日志
          return isAppen
        } else if (item.id === 4 && scope.row.cochain &&(scope.row.cochain === 1 || scope.row.cochain === 2) && item.isShow) {
          // 区块链
          return isAppen
        } else if (item.id === 5 && this.widgetDataObj.oqrcore && item.isShow) {
          // 数据二维码
          return isAppen
        }
        // else if (item.id === 7 && this.widgetDataObj.lookqrcode === 1 && item.isShow) {
        //   // 查看二维码
        //   return isAppen
        // }
        else if (item.id === 6 && JSON.stringify(scope.row.archive) && this.widgetDataObj.archive && item.isShow) {
          // 数据归档
          return isAppen
        } else if ([1, 2, 3, 4, 5, 6].indexOf(item.id) === -1) {
          return isAppen
        }
      })
      if (scope.row.archive) {
        arr = arr.filter(item => {
          if (item.id === 1 && !this.isDelAndEdit(scope.row, 'update')) {
            return false
          } else if (item.id === 2 && !this.isDelAndEdit(scope.row, 'delete')) {
            return false
          } else {
            return true
          }
        })
      }
      return arr
    },
    getContentClass(item) {
      // if (item.type === 'textarea') {
      //   return ''
      // }
      const val = this.isDoor ? item.isOpen ? 'nowrap' : 'door-ellipsis' : 'ellipsisTwo ellipsisTwo'
      return val
    },
    getWidth(item, type) {
      let w = ''
      if (this.isDoor) {
        if (item.isOpen) {
          const widthArr = []
          let maxw = 0
          this.$refs[`${item.title}-column`].forEach(f => {
            f.classList.remove('nowrap')
            f.classList.add('nowrap')
            const len = f.scrollWidth
            widthArr.push(len)
          })
          maxw = Math.max(...widthArr) + 20
          return maxw
        }
        if (type === 'sel') {
          w = 40
        } else if (type === 'num') {
          w = this.tableStyleField.idxWidth || 50
        } else {
          if (this.isFixed) {
            w = item.percentageW
          } else {
            w = item.w
          }
        }
      }
      return w
    },
    // 归档 or 解除归档
    async archiveFun (item) {
      const res = await archivedata({
        approvalId: this.$route.query.approvalId || this.approvalId,
        approvingId: item.approvingId,
        isarchive: item.archive ? 0 : 1,
      });
      if (res.code === 0) {
        this.$message.success(item.archive ? "解除归档成功！" : "归档成功！");
        item.archive = !item.archive;
      }
    },
    // 批量回来
    batchRet (val) {
      if (this.batch.operate === "del") {
        if (val.radio === 1) {
          this.deleteRowFun(2);
        } else {
          this.setDeletebycondition(val);
        }
      } else if (this.batch.operate === "export") {
        this.checkShowSet = (val.center || []).filter((item) => {
          return item.checked;
        });
        this.exportexcel(val);
      } else if (this.batch.operate === "update") {
        // 这里是修改回来
        const obj = {
          approvalId: this.$route.query.approvalId || this.approvalId,
          reportFormId: this.searchCriteria.reportFormId,
          type: 0,
          curpage: 1,
          pagesize: 10000,
          cateId: -1,
          key: this.searchCriteria.key,
          conditionconfig: val.conditionconfig,
        };
        if (val && val.radio === 1) {
          obj.approvingIds = (this.multipleSelection || [])
            .map((its) => its.approvingId)
            .join(",");
        } else if (val && val.radio === 2) {
          obj.query = this.searchCriteria.query;
        } else if (val && val.radio === 3) {
          obj.query = { date_timeof: val.time };
        }
        if (val.isarchive !== "") obj.isarchive = val.isarchive;
        this.batchUpdate(obj);
      }
      this.batch = {
        visible: false,
        title: "",
        operate: "",
      };
    },
    // 批量修改
    async batchUpdate (item) {
      const res = await batchupdatedata(item);
      if (res.code === 0) {
        ElMessage({ type: "success", message: "操作成功" })      
        this.getDataList(0);
        this.$emit("retRefresh");
      } else {
        ElMessage({ type: "error", message: res.msg || '操作失败' })
      }
    },
    // 批量删除
    async setDeletebycondition (item) {
      const param = {
        approvalId: this.$route.query.approvalId || this.approvalId,
        reportFormId: this.searchCriteria.reportFormId,
        type: 0,
        curpage: 1,
        pagesize: 10000,
        cateId: -1,
        key: this.searchCriteria.key,
      };
      if (item && item.radio === 2) {
        param.query = this.searchCriteria.query;
      } else if (item && item.radio === 3) {
        param.query = { date_timeof: item.time };
      }
      const res = await deletebycondition(param);
      if (res.code === 0) {
        this.$message.success(res.msg || "删除成功!");
        // 计算删除之后的数据列表
        if (
          this.listData.data.length === 0 && this.searchCriteria &&
          this.searchCriteria.curpage > 1
        ) {
          this.searchCriteria.curpage -= 1;
        }
        this.getDataList(0);
        this.$emit("resetRefresh", "del");
      } else {
        this.$message.error(res.msg || "删除失败!");
      }
    },
    // 查看日志
    viewLogFun (item) {
      this.logApprovingId = item.approvingId;
      this.isViewLog = true;
    },
    // 全部审批
    allApprove (val) {
      if (
        (!val && this.multipleSelection.length === 0) ||
        (val && this.listData.data.length === 0)
      ) {
        this.$message.error("请选择需要处理的数据!");
        return false;
      }
      this.allBatch = val;
      if (
        (val && this.listData.total > 50) ||
        (!val && this.multipleSelection.length > 50)
      ) {
        this.maximumLimit();
      } else {
        this.isBatch = true;
      }
    },
    // 大于50提示
    maximumLimit () {
      const self = this;
      this.$statusMsg.message({
        title: "批量审批不能多于50条，本次处理前50条数据，是否继续？",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmFun: function (action) {
          if (action === "confirm") {
            self.isBatch = true;
          }
        },
      });
    },
    // 批量审批的刷新
    batchRefresh () {
      // 重置选中数据
      this.multipleSelection = [];
      this.$emit("resetRefresh", "del");
    },
    // 搜索
    goFilter (e) {
      if (JSON.stringify(e) !== "{}") {
        this.searchCriteria.query = JSON.stringify(e);
      } else {
        delete this.searchCriteria.query;
      }
      //搜索设置值
      this.searchCriteria.curpage = 1;
      this.searchCriteria.pagesize = 25;
      this.getDataList(0);
    },
    //- 表单selec是否可以选中
    selectableFun (row) {
      //- cochain   上链0:无操作，1是上链中，2上链成功，3上链失败
      let whether = true;
      if (this.blockchainChange === true) {
        //- 区块链模式下
        //- 上链失败，无操作不能选中
        if (row["状态"] !== "已通过") {
          whether = false;
        } else {
          // if (row.cochain === 1 || row.cochain === 2) {
          //   whether = false;
          // }
        }
      } else {
        //- 正常模式下
        // if (row.cochain === 1 || row.cochain === 2) {
        //   whether = false;
        // }
      }
      //- return 值true是可以，false是不行
      return whether;
    },
    //- 表格勾选状态变化
    handleSelectionChange (val) {
      this.multipleSelection = val;
      this.$store.commit('getTableData', val); // ai小易-数据表格存储选中数据
      if (this.listInfo) {
        this.$emit("update:multipleSelection", val);
      }
    },
    //- 判断当上传区块链时候是否展示按钮
    blockchaiButtonShow (row) {
      //- cochain   上链0:无操作，1是上链中，2上链成功，3上链失败
      let whether = true;
      // if (this.blockchainChange === true) {
      if (row.cochain === 1 || row.cochain === 2) {
        whether = false;
      }
      // }
      return whether;
    },
    //- 表格名称判断
    upClass ({ row }) {
      let str = "row_style";
      if (row.cochain === 1 || row.cochain === 2) {
        str += " row_style_back";
      }
      for (const ele of this.tableKey) {
        if (!ele.filedInfo) continue
        if (!ele.filedInfo.isColor) continue
        const colorType = ele.filedInfo.colorType
        if (colorType === '3') {
          str += ' row_style_wholerow'
        }
      }
      return str;
    },
    //- 批量导出附件是否显示判断
    panduanShow (listData) {
      let whether = "";
      if (
        listData &&
        listData.data.length > 0 &&
        (this.$route.query.approvalId || this.approvalId) != 10288 &&
        (this.$route.query.approvalId || this.approvalId) != 10318 &&
        (this.$route.query.approvalId || this.approvalId) != 10156 &&
        (this.$route.query.approvalId || this.approvalId) != 10345 &&
        (this.$route.query.approvalId || this.approvalId) != 10344
      ) {
        whether = true;
      } else {
        whether = false;
      }
      return whether;
    },
    //- 批量操作
    handleCommand (val) {
      if (val == "批量导入") {
        this.bulkImport();
      } else if (val == "批量导出附件") {
        // 这个要回去看下是否要验证
        this.$emit("smsVerifi", "batchFileFun");
      } else if (val == "批量删除") {
        this.deleteRow(2);
      } else if (val == "批量导出报表") {
        this.$emit("smsVerifi", "getuserreport");
        // this.getuserreport(0);
      } else if (val == "上传区块链") {
        this.getDataList(0);
        setTimeout(() => {
          this.blockchainChange = true;
        }, 1000);
      } else if (val == "批量修改") {
        this.batch = {
          visible: true,
          title: "修改",
          operate: "update",
          repeat: true,
          batchQuery: this.searchCriteria.query || "",
          dateLen: this.multipleSelection.length,
        };
      } else if (Number(val) === 4) {
        this.batchApproval = true;
      }
    },
    // 批量导出附件
    batchFileFun () {
      this.downLoadShow = true;
      this.getFrom();
      let datas = this.getTransmitDatas();
      console.log(1)
      this.$nextTick(() => {
        this.$refs.accessoryRef.openAccessory(datas, this.querys);
      });
    },
    // 遍历加东西
    findAdd (val) {
      //- type代表当前数据，title代表fathertype值，val代表当前循环的list数据
      let new_array = []; //- 新数组
      let datas = JSON.parse(JSON.stringify(val));
      for (let index = 0; index < datas.length; index++) {
        if (
          ["ready-widget", "label", "checkbox", "richTextWid"].indexOf(
            datas[index].type
          ) === -1
        ) {
          //- 第一级fathertype补全
          if (datas[index].fatherType == undefined) {
            //- 说明字段fatherType不存在就要补全
            datas[index].fatherType = "";
          }
          //- 明细或者新版管联数据判断
          let list_one = datas[index].list;
          if (list_one && list_one.length > 0) {
            //- 可能是明细还是关联单选控件
            list_one.forEach((item) => {
              item.fatherType = datas[index].title + "_" + datas[index].type;
              item.name = datas[index].name + "." + item.name;

              //- 明细可能有第二层list数据
              let second_list = item.list;
              if (second_list && second_list.length > 0) {
                second_list.forEach((item2) => {
                  if (
                    [
                      "ready-widget",
                      "label",
                      "checkbox",
                      "richTextWid",
                    ].indexOf(item2.type) === -1
                  ) {
                    item2.name = item.name + "." + item2.name;
                    item2.fatherType =
                      datas[index].title +
                      "_" +
                      datas[index].type +
                      "." +
                      item.title +
                      "_" +
                      item.type;
                    item2.tier = 3;
                    new_array.push(item2);
                  }
                });
              } else {
                //- 说明没有下一层数据就直接加入数据
                if (
                  ["ready-widget", "label", "checkbox", "richTextWid"].indexOf(
                    item.type
                  ) === -1
                ) {
                  item.tier = 2;
                  new_array.push(item);
                }
              }
            });
          } else {
            //- 当前没有没有明细数据或者关联数据(第一级)

            datas[index].tier = 1;
            new_array.push(datas[index]);
          }
        }
      }
      return new_array;
    },
    //- 获取当前表单的字段
    getFrom () {
      let that = this;
      let param = { approvalId: this.$route.query.approvalId || this.approvalId };
      if (this.$route.query.spaceid || localStorage.getItem('spaceid')) {
        param.spaceid = this.$route.query.spaceid || localStorage.getItem('spaceid')
      }
      else if (this.$route.query.upaceid || localStorage.getItem('upaceid')) {
        param.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
      }
      axiosBase(param,
        "/openapi/getapproval"
      ).then(async (res) => {
        if (res.code === 0) {
          let field = JSON.parse(res.data.property);
          const appname = res.data.appname
          field = field.filter((val) => {
            if (val.list && val.list.length > 0)
              val.list = val.list.filter((items) => {
                return items.type !== "label";
              });
            return val.type !== "label";
          });
          // 遍历给每个有list 的参数加东西
          field = that.findAdd(field);
          field.unshift(
            {
              name: "申请人",
              type: "relation-user",
              title: "申请人",
              fatherType: "",
              tier: 1,
            },
            {
              name: "单号",
              type: "text",
              title: "单号",
              fatherType: "",
              tier: 1,
            },
            {
              name: "状态",
              type: "status",
              title: "状态",
              fatherType: "",
              tier: 1,
            },
            {
              name: "提交时间",
              type: "date",
              title: "提交时间",
              fatherType: "",
              tier: 1,
            }
          );

          let arrs = []; //- 最后转换的数据内容

          field.forEach((val) => {
            let date = {
              type: val.type,
              name: val.name,
              title: val.title,
              fatherType: val.fatherType,
              tier: val.tier,
            };
            if (val.sels) date.sels = typeof val === 'string' ? JSON.parse(val.sels) : val.sels;
            if (val.types) date.types = val.types
            // if (val.type !== 'details' && val.type !== 'new-rel-radio' && val.type !== 'ready-widget')
            arrs.push(date);
          });
          // 获取一下打印模板
          let printConfig
          if (res.data && res.data.pageset) {
            printConfig = JSON.parse(res.data.pageset)
            if (printConfig && printConfig.url) {
              printConfig = await getConfigFromUrl(this.$url + printConfig.url)
            }
          }
          this.$nextTick(() => {
            this.$refs.accessoryRef.setFromDatas(arrs, printConfig, appname);
          });
        }
      });
    },
    //- 获取批量导出传递数据
    getTransmitDatas () {
      let searchCriteria = JSON.parse(JSON.stringify(this.searchCriteria));
      let activeTypeName = this.activeTypeName;
      let param = {
        reportFormId: searchCriteria.reportFormId, //- 报表ID
        zipcontent: "", //- 附件下载配置文件
        ziptype: this.userId === true ? 1 : 0, //- 0：全校；1个人
        approvalId: this.$route.query.approvalId || this.approvalId, //- 	应用ID
        approvingIds: "", //- 选择数据时拼接ID
        key: searchCriteria.key, //- 搜索标题或发起人名称
        query: searchCriteria.query, //- 筛选条件
      };
      //- 确认是否有选择id
      if (this.multipleSelection.length > 0) {
        //- 说明有选择id，需要拼接
        let id_array = [];
        this.multipleSelection.forEach((item) => {
          id_array.push(item.approvingId);
        });
        id_array = id_array.join(",");
        param.approvingIds = id_array;
      }

      //- 4:全部,0:我发起的,3:关于我的,1:待办的,2:已办的
      if (activeTypeName === 4) {
        param.type = 0;
        param.selfuser = 0;
        param.both = 1;
      } else if (activeTypeName === 0) {
        param.type = 0;
      } else if (activeTypeName === 3) {
        param.selfuser = 0;
      } else if (activeTypeName === 1) {
        param.type = 1;
        param.status = 0;
      } else if (activeTypeName === 2) {
        param.type = 1;
        param.status = "1,2";
        param.way = "1,2,4";
      }
      return param;
    },
    //修改
    tableUpdate (data, info) {
      //更新父级。因为是弹窗所以放到父组件上
      const param = {
        key: 2,
        data: data,
      };
      if (info && info.pageType) {
        param.pageType = info.pageType
      }
      this.detailOpenType = 'detail'
      this.$emit("sourceAudit", param);
    },
    //删除数据
    deleteRow (type, index, key) {
      // 这里要换成多选弹窗(新版的)
      if (type === 2) {
        this.batch = {
          visible: true,
          title: "删除",
          operate: "del",
          repeat: true,
          batchQuery: this.searchCriteria.query || "",
          dateLen: this.multipleSelection.length,
        };
      } else {
        // type:1单个删除，2多个删除, 3单个删除 直接使用approvingId删除不需要通过index查询
        this.$confirm("确定要删除？", {
          confirmButtonClass: "el-button--yeprimary",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            if (type === 1 || type === 3) {
              this.deleteRowFun(type, index, key);
            } else {
              this.deleteRowFun(2);
            }
          })
          .catch(() => { });
      }
    },
    //二维码生成方式
    onQrcodeCommand (command) {
      this.dialogvueqr = true;
      this.$nextTick(function () {
        this.$refs.vueqrcoderef.onQrcodeCommand(command);
      });
    },
    //表格删除方法
    deleteRowFun (res, index, key) {
      //type:1单个删除，2多个删除.index单个删除 3 直接把approvingId传过来了 不用通过index去查approvingId
      const resIsDel = res;
      let tableData = this.listData.data;
      let param = {
        approvalId: this.$route.query.approvalId || this.approvalId,
      };
      if (resIsDel === 1) {
        param.approvingId = tableData[index].approvingId;
      } else if (resIsDel === 3) {
        param.approvingId = index
      } else {
        const arr = (this.multipleSelection || []).map(
          (its) => its.approvingId
        );
        param.approvingId = arr.length === 1 ? arr[0] : arr;
      }
      this.fullScreenLoading = true;
      axiosBase(param, "/api/deleteapproving").then((res) => {
        this.fullScreenLoading = false;
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          if (resIsDel === 1) {
            //单个视图跟新
            tableData.splice(index, 1);
            if (key === 'card') {
              this.$emit('cardDataDel', index)
            }
          } else {
            //多个视图更新和单个
            if (typeof param.approvingId == "number") {
              //单个
              this.listData.data.forEach((el2, index) => {
                if (el2.approvingId == param.approvingId) {
                  this.listData.data.splice(index, 1);
                }
              });
            } else {
              param.approvingId.forEach((el) => {
                this.listData.data.forEach((el2, index) => {
                  if (el == el2.approvingId) {
                    this.listData.data.splice(index, 1);
                  }
                });
              });
            }
          }
          // 计算删除之后的数据列表
          if (
            this.listData.data.length === 0 && this.searchCriteria &&
            this.searchCriteria.curpage > 1
          ) {
            this.searchCriteria.curpage -= 1;
          }
          this.getDataList(0);
          this.$emit("resetRefresh", "del");
          // this.$emit("resetRefresh");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //- 区块链上链
    blockchainUpload () {
      const that = this;
      let tableDataChe = that.multipleSelection;
      if (tableDataChe.length === 0) {
        that.$message.error("请选择要上链的数据");
      } else {
        let id_array = tableDataChe.map((item) => {
          return item.approvingId;
        });
        let param = {};
        param.approvalId = that.approvalId;
        param.approvingIds = id_array;

        addcochain(param)
          .then((res) => {
            if (res.code === 0) {
              setTimeout(() => {
                that.$message.success("上链成功");
                that.uploadKey += 1;
                this.getDataList(0);
              }, 500);
            } else {
              that.$message.error(res.msg);
            }
          })
          .catch((error) => {
            console.log("区块链上链报错", error);
          });
      }
    },
    strData(e, n) {
      if (e instanceof Array) {
        //如果为数组
        if (e[0] && e[0].userId) {
          //如果有userId说明是联系人控件
          let ej = [];
          e.forEach((i) => {
            ej.push(i.realname);
          });
          return ej.join(",");
        } else if (e[0] && (e[0].organizationId || e[0].roleId)) {
          //如果有organizationId或roleId说明是组织控件或角色控件
          let ej = [];
          e.forEach((i) => {
            let name = i.name
            if (i.organizationId) {
              name = getOrgShowName(i)
            }
            ej.push(name);
          });
          return ej.join(",");
        } else {
          return e.join(",");
        }
      } else {
        return sliceEncrypt(e, n);
      }
    },
    //计算表头宽度
    countTable (res) {
      let table = [];
      let tableArr = [];
      if (this.tableKey.length > 0) {
        table = JSON.parse(JSON.stringify(this.tableKey));
        for (let i in table) {
          let width = table[i].title.length * 14;
          if (width > 400) {
            table[i].width = 400;
          } else if (width < 100) {
            table[i].width = 100;
          } else {
            table[i].width = width;
          }
          tableArr.push(table[i].title);
        }
      }
      if (
        this.listData &&
        this.listData.data &&
        this.listData.data.length > 0
      ) {
        //计算表格里面字符数据
        let list = JSON.parse(JSON.stringify(this.listData.data));
        for (let i in list) {
          for (let a in list[i]) {
            //进行匹配
            let index = tableArr.indexOf(a);
            if (index !== -1) {
              let len = list[i][a].length * 14;
              if (len > table[index].width && len > 400) {
                table[index].width = 400;
              } else if (len > table[index].width && len < 400) {
                table[index].width = len;
              }
            }
          }
        }
      }
      this.tableKey = table;
      if (res === 4) {
        this.obtainHeight(4);
      }
      const self = this;
      setTimeout(function () {
        try {
          self.$refs.transaction.doLayout();
        } catch (e) {
          // TODO
        }
      }, 10);
    },
    obtainHeight (e) {
      let self = this;
      if (e) {
        self.switchNav = e;
      }
    },
    statusFun (val) {
      return tableStatus(val);
    },
    handleSizeChange (val) {
      if (this.listInfo) {
        this.listData.pagesize = val;
        // eslint-disable-next-line vue/no-mutating-props
        this.listInfo.tablePageSize = val;
        this.$emit("update:listInfo", this.listInfo);
        this.$emit("change-currpage");
      } else {
        this.searchCriteria.pagesize = val;
        this.searchCriteria.curpage = 1;
        this.listData.currentPage = 1;
        this.getDataList(0);
      }
    },
    handleCurrentChange (val) {
      if (this.listInfo) {
        // eslint-disable-next-line vue/no-mutating-props
        this.listInfo.currentPage = val;
        this.$emit("update:listInfo", this.listInfo);
        this.$emit("change-currpage");
      } else {
        this.searchCriteria.curpage = val;
        this.listData.currentPage = val;
        this.getDataList(0);
      }
    },
    emptyBtn () {
      this.query.forEach((e) => {
        e.value = []
        if (e.type == "number") {
          e.value = ''
          e.min = "";
          e.max = "";
        }
      });
      this.searchCriteria = JSON.parse(JSON.stringify(this.searchDefault));
      // this.searchCriteria.query={}
      this.getDataList(0);
    },
    getDataList (item) {
      if (this.listData && item != 0) {
        return;
      }
      this.blockchainChange = false;
      this.fullScreenLoading = true;
      if (this.searchCriteria && this.searchCriteria.inform) {
        //告知我的，另外接口
        const paramT = JSON.parse(JSON.stringify(this.searchCriteria));
        axiosBase(paramT, "/api/getuserfieldccdatalist").then((res) => {
          if (res && res.code == 0) {
            this.listData = res;
            this.listData.currentPage = this.searchCriteria.curpage;
            //全部加载一次
            if (item === 4) {
              this.countTable(4);
            } else {
              this.countTable();
            }
            this.fullScreenLoading = false;
          }
        });
        return;
      }
      if (this.userId) {
        //全部
        let param = this.searchCriteria;
        if (item === 4) {
          const param2 = JSON.parse(JSON.stringify(this.searchCriteria));
          param = {};
          param.curpage = param2.curpage;
          param.pagesize = param2.pagesize;
          param.cateId = param2.cateId;
          param.key = param2.key;
          param.type = 0;
          param.reportFormId = param2.reportFormId;
          param.selfuser = 0;
          param.both = 1;
          param.approvalId = param2.approvalId;
          if (param2.query) param.query = param2.query;
        }
        if (this.querys) {
          param.querys = this.querys ? this.querys : "";
        }
        // 从空间进入，需要传空间id
        if(this.isSpace){
          let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
          param.spaceid = spaceId;
        }
        else if (this.isUpace) {
          let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
          param.upaceid = upaceId
        }
        axiosBase(param, "/api/getuserfielddatalist").then((res) => {
          if (res && res.code == 0) {
            this.listData = res;
            this.listData.currentPage = this.searchCriteria.curpage;
            this.countTable();
            this.fullScreenLoading = false;
            this.handleTableTodo(res.data[0])
          }
        });
      } else {
        // 从空间进入，需要传空间id
        if(this.isSpace){
          let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
          this.searchCriteria.spaceid = spaceId;
        }
        else if (this.isUpace) {
          let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
          this.searchCriteria.upaceid = upaceId
        }
        // ai小易配置隐藏，则获取全部数据
        if(this.aitableHide){
          this.searchCriteria.pagesize = 0
        }
        getapifielddatalist(this.searchCriteria)
          .then((res) => {
            if (res && res.code == 0) {
              this.listData = res;
              this.listData.currentPage = this.searchCriteria.curpage;
              this.countTable();
              this.fullScreenLoading = false;
              this.handleTableTodo(res.data[0])
              // ai小易配置隐藏，则默认勾选全部数据
              if(this.aitableHide){  
                this.$nextTick(() => {
                  if (this.$refs.transaction) {
                    this.$refs.transaction.toggleAllSelection();
                  }
                })
              }
            }
          })
          .catch(() => { });
      }
      this.obtainHeight(item);
    },
    // 查询label
		getTimeLabel (val, sels) {
			if (!val || !sels || sels.length === 0) return val
			const v = val.split(' ')
			for (const i of sels) {
				if (i.value === v[1]) return v[0] + ' ' + i.label
			}
			return val
		},
    handleTableTodo(value){
      const id = this.$route.query.iId
      if (id) {
        if (id == 15 || id == 16) {
          // 打开数据详情
          value?this.tableDetail(value):this.$message.error('暂无数据')
        }else if(id == 13 || id == 14){
          // 打开数据编辑
          if (!this.isFirstEdit) {
            value?this.tableUpdate(value):this.$message.error('暂无数据')
            this.isFirstEdit = true
          }
        }
      }
    },
    menuListMethod (item, searchCriteria, key, index) {
      console.log('位置了', item)
      this.widgetDataObj = JSON.parse(JSON.stringify(item)); //保存数据
      item = JSON.parse(JSON.stringify(item));
      if (item.qrcodetypes) this.widgetDataObj.qrcodetypes = JSON.parse(item.qrcodetypes)
      if (item.lookqrcodetypes) this.widgetDataObj.lookqrcodetypes = JSON.parse(item.lookqrcodetypes)
      this.menuListActive = key;
      // 存一个 approvalId 用来辨别配置
      if (
        this.approvalId === this.approvalIds &&
        this.searchCriteria &&
        this.searchCriteria.query
      ) {
        searchCriteria.query = this.searchCriteria.query;
      } else {
        this.query = [];
        if (typeof item.query == "string") {
          item.query = JSON.parse(item.query);
        }
        item.query.forEach((e) => {
          if (e.checked) {
            if (e.type == "radio" || e.type == "checkbox") {
              if (typeof e.sels == "string") {
                e.sels = JSON.parse(e.sels);
              }
              e.value = []
            } else if (e.type == "status") {
              e.value = []
            } else if (e.type == "data") {
              // TODO
            }
            this.query.push(e);
          }
        });
      }
      this.approvalIds = this.approvalId;

      searchCriteria.approvalId = this.$route.query.approvalId || this.approvalId;
      this.searchCriteria = searchCriteria;
      if (searchCriteria.querys) {
        this.querys = searchCriteria.querys;
      }
      if (item.reportFormId) {
        this.searchCriteria.reportFormId = item.reportFormId;
      }
      this.searchDefault = JSON.parse(JSON.stringify(this.searchCriteria));
      if (item.userId) {
        //个人报表
        this.userId = true;
      } else {
        //学校报表
        this.userId = false;
      }
      if (item.userReport && item.userReport.content) {
        var content = JSON.parse(item.userReport.content);
        this.tableKey = [];
        for (var i = 0; i < content.length; i++) {
          // 容器控件不显示
          if (content[i].checked && content[i].type !== 'container') {
            this.tableKey.push(content[i]);
          }
        }
        //表头判断
        // 因为不加载全部了，只要有 index 参数就是第一次
        if (index || index === 0) {
          this.listData = null;
          this.getDataList(index);
          this.countTable(index);
        } else {
          this.countTable();
          this.listData = null;
        }
      } else {
        alert("表头数据错误");
      }
      this.heHeightAuto();
    },
    fieldAllChange (val) {
      // this.checkShowSet = val ? this.showSets : [];
      // this.isIndeterminate = false;
      //显示设置过滤明细控件
      let newArr = [];
      if (this.dialogFieldSet.botton == 1) {
        this.showSets.forEach((el) => {
          if (el.type != 'details' || el.type != 'container') {
            newArr.push(el);
          }
        });
      } else {
        newArr = this.showSets;
      }
      this.checkShowSet = val ? newArr : [];
      this.isIndeterminate = false;
    },
    fieldChange (value) {
      let checkedCount = value.length;
      this.checkAllField = checkedCount === this.showSets.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.showSets.length;
    },
    openDetailInfo(arge = [], row) {
      const [type, dataInfo] = arge
      this.tableDetail(row, true, dataInfo, type)
    },
    async tableDetail(row, isTodo = false, dataInfo, type = 'app-detail') {
      this.$emit('click-row', row)
      this.detailOpenType = type
      if (isTodo === true) {
        const openType = {
          2: 'dialog',
          3: 'new',
          4: 'old',
          5: 'rightdia'
        }
        let openInfo = {}
        if (dataInfo.insideInfo) {
          const { open, popUps } = dataInfo.insideInfo
          const { pageType } = dataInfo
          const { customSize, diaSize  } = popUps
          openInfo = {
            openAction: openType[open],
            customSize,
            diaSize,
            pageType
          }
        } else {
          openInfo = {
            openAction: openType[5],
            customSize: '80%',
          }
        }
        if(dataInfo.appAgentConfig){
          openInfo.appAgentConfig = dataInfo.appAgentConfig
        }
        this.openDetail(row, openInfo)
        return
      }
      const clickEffect = this.clickEffect.effect
      if (clickEffect === 'notodo') {
        // TODO
      } else if (clickEffect === 'inside') {
        this.$emit('click-table',row)
      } else {
        if (this.navIndex !== 1 && row && row.linkconfig && row.linkconfig.open && row.linkconfig.field && row.linktype && (row.linktype === '1' || row.linktype === JSON.stringify('1'))) {
          const v = row.linkconfig.field.split('_')[0]
          this.linkConfig = row.linkconfig
          await this.$nextTick()
          this.$refs.widgetLinkOpen.open(row[v])
          return
        }
        this.openDetail(row)
      }
    },
    openDetail(row, openInfo) {
      let param = {
          approving: {
            approvingId: row.approvingId,
          },
          userapprovingId: row.userApprovingId,
          approvalId: this.$route.query.approvalId || this.approvalId,
        };
        // openAction ===>打开页面方式 new新页面 old原页面
        let openAction = this.openAction
        let diaSize = this.pageList.openAction
        let customSize = this.pageList.customSize
        if (openInfo) {
          openAction = openInfo.openAction
          diaSize = openInfo.diaSize
          customSize = openInfo.customSize
          param.pageType = openInfo.pageType
        }
        if (Number(this.navIndex) === 3) {
          // 给到是否有删除和查看日志权限
          param.delete = this.widgetDataObj.delete
          param.myoplog = this.widgetDataObj.myoplog
          param.update = this.widgetDataObj.update
          if(openInfo && openInfo.appAgentConfig){
            param.appAgentConfig = openInfo.appAgentConfig
          }
          this.$refs.AuditOpenChild.AuditOpenList(param, 1);
        } else if (openAction === 'old') {
          this.$router.push({
            name: 'oaExamineAuditPage',
            params: {
              data: param
            }
          })

        } else if (openAction === 'new') {
          let routeUrl = this.$router.resolve({
            name: 'oaExamineAuditPage',
            query: {
              data: JSON.stringify(param)
            }
          });
          window.open(routeUrl.href, "_blank");
        } else {
          this.componentType = openAction
          if (diaSize === 'custom') {
            diaSize = customSize + '%'
          }
          this.diaSize = diaSize
          param.delete = this.widgetDataObj.delete
          param.myoplog = this.widgetDataObj.myoplog
          param.update = this.widgetDataObj.update
          this.$refs.AuditOpenChild.AuditOpenList(param)
        }
    },
    sourceAudit (param) {
      //来源oaExamineAudit.vue的方法
      if (param && param.key == 0) {
        this.secondData.data.forEach((el, index) => {
          if (el.userapprovingId == param.userapprovingId) {
            this.secondData.data.splice(index, 1);
            this.secondnum = this.secondnum - 1;
          }
        });
        this.thirdData = null;
      } else {
        // 回去刷新重新获取数据
        this.$emit("resetRefresh");
      }
    },
    //批量导入
    bulkImport () {
      //更新父级
      const param = {
        key: 1,
      };
      this.$emit("sourceAudit", param);
    },
    getuserreport (key) {
      //显示设置
      if (key == 0) {
        //0为导出字段
        this.dialogFieldSet = {
          title: "设置导出字段",
          botton: 0,
        };
      } else {
        this.dialogFieldSet = {
          title: "显示字段",
          botton: 1,
        };
      }
      this.fullScreenLoading = true;
      axiosBase(
        { reportFormId: this.searchCriteria.reportFormId },
        "/api/getuserreport"
      ).then((res) => {
        if (res && res.code == 0) {
          this.userReportId = res.data.userReportId;
          var content = res.data.content || [];
          this.showSets = [];
          this.checkShowSet = [];
          for (var i = 0; i < content.length; i++) {
            this.showSets.push(content[i]);
            if (content[i].checked) {
              this.checkShowSet.push(content[i]);
            }
          }
          const index = this.showSets.findIndex(item => { return item.title === '新闻标题' })
          if (index === -1) {
            this.showSets.unshift({
              type: 'text',
              title: '新闻标题',
              name: '新闻标题',
              checked: false
            })
          }
          this.fieldChange(this.checkShowSet);
          // 批量导出报表走弹出新弹窗
          if (key == 0) {
            this.batch = {
              visible: true,
              title: "导出",
              operate: "export",
              dateLen: this.multipleSelection.length,
              batchQuery: this.searchCriteria.query || "",
              center: content,
            };
          } else {
            this.dialogFieldVisible = true;
          }
          this.fullScreenLoading = false;
        }
      });
    },
    exportexcel (item) {
      // 固定参数
      const param = JSON.parse(JSON.stringify(this.searchDefault));
      param.curpage = 0;
      param.pagesize = 0;
      const checkShowSet = JSON.parse(JSON.stringify(this.checkShowSet));
      checkShowSet.forEach((e) => {
        e.checked = true;
      });
      param.content = JSON.stringify(checkShowSet);
      param.reportFormId = this.searchCriteria.reportFormId;
      param.key = this.searchCriteria.key;

      if (item.radio === 1) {
        param.approvingIds = this.multipleSelection
          .map((its) => its.approvingId)
          .join(",");
      } else if (item.radio === 2) {
        param.query = this.searchCriteria.query;
      } else if (item.radio === 3) {
        param.query = { date_timeof: item.time };
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        param.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        param.upaceid = upaceId
      }
      const appid = this.$route.query.approvalId || this.approvalId || this.appid
      if (appid) {
        param.approvalId = appid
      }
      // 第三个参数是导出的接口过期时间
      axiosBase(param, "/api/exportreport", 60 * 1000 * 3).then((res) => {
        if (res && res.code == 0) {
          filePreview({ url: res.data }, true);
          this.dialogFieldVisible = false;
        }
      });
    },
    FieldSubmit () {
      //显示设置确定
      this.showSets.forEach((el) => {
        el.checked = false;
        this.checkShowSet.forEach((ele) => {
          if (el.name == ele.name) {
            el.checked = true;
          }
        });
      });
      this.fullScreenLoading = true;
      axiosBase(
        {
          content: JSON.stringify(this.showSets),
          userReportId: this.userReportId,
        },
        "/api/updateuserreport"
      ).then((res) => {
        this.dialogFieldVisible = false;
        if (res && res.code == 0) {
          // 过滤容器控件
          this.checkShowSet = this.checkShowSet.filter(item =>{
            return item.type !== 'container'
          })
          this.tableKey = this.checkShowSet;
          this.countTable();
          // this.menuListDatas[this.menuListActive].userReport.content=JSON.stringify(content)//中间菜单显示出来才有用
          this.getDataList(0);
        }
      });
    },
    // 返回定位控件值
    getLocationVal(data){
      console.log("data==",data)
      if(data == '') return ''
      const val = typeof data === 'string' ? JSON.parse(data) : data
      console.log("val==",val)
      if(val.length > 0){
        return val[0]['addressName']
      }
      else{
        return ''
      }
    },
    //何高度计算
    heHeightAuto () {
      let heiN = this.$store.state.heightAuto;
      //有搜索条件
      if (this.query.length > 0) {
        heiN -= 30;
      }
      //iframe。应用进来的  这边注释 是因为在中台显示的时候会跨域 把这个注释掉 如果哪里出现了问题 再想办法解决
      // const frameWin = window.parent.document.getElementById("show-iframe");
      // if (frameWin) {
      //   heiN += 80;
      // }
      this.tableHeight2 = !this.$route.query.navShow === false ? heiN += 200 : heiN;
    },
    watchScrollToBootom() {
      if (!this.$refs.transaction) return
      const scrollbarEl = this.$refs.transaction.bodyWrapper
      if (!scrollbarEl) return
      this.tableWidth = scrollbarEl.offsetWidth + 'px'
      scrollbarEl.onscroll = (el) => {
        if (isScrollAtBottom(el) && this.tableStyleField.loadingMethod === 'scroll') {
          this.$emit('toBottom')
        }
        if (isScrollAtRight(el, 100) && this.checkSyllable.length > 50) {
          this.setTableKey()
        }
      }
    },
  },
  mounted () {
    if (!this.isDoor) {
      this.heHeightAuto();
    }
    if (this.titleForRow) {
      this.$nextTick(()=>{
        setTimeout(() => {
          this.tableHeight = this.getTableHeight
        }, 500);
      })
    }
    setTimeout(() => {
      if (this.tableStyleField.isTodoList) {
        this.handleTodoConfig()
      }
    }, 500)
  },
  beforeDestory() {
    const scrollbarEl = this.$refs.transaction.bodyWrapper
    scrollbarEl.onscroll = null
  },
  watch: {
    batchadd: {
      immediate: true,
      handler (val) {
        if (!val) {
          this.batchApproval = false;
        }
      },
    },
    "$store.state.heightAuto": {
      immediate: true,
      handler () {
        if (!this.isDoor) {
          this.heHeightAuto();
        }
      },
    },
    listInfo: {
      handler (val) {
        console.log('listInfo初始数据', val)
        if (val && val.tableData) {
          const date = cloneDeep(val.tableData)
          const data = date.slice(0, 35)
          const resData = date.slice(35, date.length)
          if (this.approvalId !== 202) {
            this.listData = {
              currentPage: val.currentPage,
              total: val.tableTotal,
              pagesize: val.tablePageSize,
              data: date,
            }
          } else {
            this.listData = {
              currentPage: val.currentPage,
              total: val.tableTotal,
              pagesize: val.tablePageSize,
              data
            }
            const tasks = []
            for (const ele of resData) {
              const fn = () => {
                this.listData.data.push(ele)
              }
              tasks.push(fn)
            }
            performTakss(tasks)
          }
          const li = this.dealDetailData(this.listData.data)
          this.listData.data = li
          if (this.listData && this.listData.data && this.listData.data.length > 0 && this.listData.data[0].content && this.listData.data[0].content.length > 0) {
            const obj = {}
            for (const i of this.listData.data[0].content) {
              if (i && i.type === 'text' && i.isLink && (i.isLink === 'true' || i.isLink === true)) {
                obj[i.title] = true
              }
            }
            this.isLinkObj = obj
          } else {
            this.isLinkObj = {}
          }
          setTimeout(() => {
            this.pageSizes.push(val.tablePageSize)
            this.pageSizes = [...new Set(this.pageSizes)]
            const btnList = []
            for (const ele of date) {
              const arr = this.tableTodoListComp({ row: ele })
              btnList.push(arr.length)
            }
            const num = Math.max(...btnList)
            if (num === 0) {
              this.todoLengthZero = true
            } else {
              this.todoLengthZero = false
            }
            for (let index = 0; index < date.length; index++) {
              const element = date[index];
              if (element.isEditTodo !== undefined) {
                break
              } else {
                element.isEditTodo = false
              }
            }
          }, 0);
          // ai小易配置隐藏，则默认勾选全部数据
          if(this.aitableHide){  
            this.$nextTick(() => {
              if (this.$refs.transaction) {
                this.$refs.transaction.toggleAllSelection();
              }
            })
          }
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.getTodoWidth()
            if (this.titleForRow && this.$refs.customRow) {
              this.$refs.customRow.init()
            }
          }, 400);
        })
      },
      deep: true,
      immediate: true,
    },
    checkSyllable: {
      handler (val) {
        if (val) {
          this.tableKey = cloneDeep(val)
        }
      },
      deep: true,
      immediate: true,
    },
    tableKey: {
      async handler(val) {
        const keyItem = val[0]
        this.uploadKey += 1
        await this.$nextTick()
        if (keyItem && keyItem.isViewOpen === undefined) {
          setTimeout(() => {
            this.tableKey.forEach(item => {
              let flag = false
              let totalWidth = 0
              const textArr = []
              const ref = this.$refs[`${item.title}-columnRef`]
              if (ref && ref[0]) {
                const client = ref[0].getBoundingClientRect()
                if(client) totalWidth = client.width
                ref.forEach(chi => {
                  const con = chi.querySelector('#tableContent')
                  if (con) {
                    const textLen = con.textContent.trim()
                    let canvas = document.createElement('canvas');
                    const context = canvas.getContext('2d');
                    const textWidth = context.measureText(textLen).width;
                    textArr.push(textWidth)
                    canvas = null
                  }
                })
                const maxText = Math.max(...textArr) + 20
                if (totalWidth < maxText) {
                  flag = true
                }
              }
              item.isViewOpen = flag
            })
          }, 300);
        }
      },
      deep: true,
      immediate:true
    },
    jurisdiction: {
      handler (val) {
        if (val) {
          this.widgetDataObj = cloneDeep(val);
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-checkbox {
  width: 16px;
  height: 16px;
  position: relative;
  border: 1px solid #DCDFE6;
  border-radius: 2px;
  display: inline-block;
  i {
    display: none;
  }
}

::v-deep .el-table {
  .el-table__body-wrapper, .row-header-style, .el-table__fixed-body-wrapper {
    .el-table__cell {
      padding: 0 !important;
    }
  }
}

// .empty-content {
//   ::v-deep .el-table {
//     .el-table__empty-block {
//       position: fixed !important;
//       top: 50% !important;
//       transform: translate(-50%, -50%) !important;
//       width: auto !important;
//       height: auto !important;
//       background: transparent !important;
//     }
//   }
// }

.radio-checkbox-active {
  background-color: #4e86ff;
  border-color: #4e86ff;
  i {
    display: block;
    font-size: 14px;
    color: #fff;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.text-link {
  text-decoration: underline;
  color: #4e86ff;
  cursor: pointer;
}
.relation-user-content {
  display: inline-block;
  margin-right: 2px;
}
::v-deep .todo-select {
  .el-input {
    .el-input__inner {
      line-height: 28px;
      height: 28px;
      border-style: solid;
    }
  }
  .el-select__caret {
    line-height: 28px;
  }
}

.rich-text {
  .rich-text-todo {
    .text {
      color: rgb(192, 196, 204) !important;
    }
  }
  .rich-text-style {
    color: #4e86ff;
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
    .text {
      margin-left: 5px;
      color: #4e86ff;
    }
    .icon-shujuchaxun {
      color: #4e86ff;
      font-size: 14px;
    }
  }
}




::v-deep .el-table {
  .row_style_wholerow {
    .cell {
      .table-content {
        color: var(--color-row) !important;
      }
    }
  }
  .el-table__row {
    .cell {
      height: 100%;
    }
  }
}

::v-deep .custom-table-title {
 .has-gutter {
    display: none;
  }
  .el-table__fixed-right {
    .el-table__fixed-header-wrapper {
      display: none;
    }
    .el-table__fixed-body-wrapper {
      height: 100%;
      top: 0 !important;
    }
  }
  .el-table__fixed {
    .el-table__fixed-header-wrapper {
      display: none;
    }
    .el-table__fixed-body-wrapper {
      top: 0 !important;
    }
  }
}

::v-deep .todo-inp {
  .el-input__inner {
    line-height: 28px;
    height: 28px;
  }
  .el-input__icon {
    line-height: 28px;
  }
}

.flex-w-h-full {
  display: flex;
  width: 100%;
  height: 100%;
}

.status-class {
  display: flex;
  width: 100%;
  height: 100%;
  margin: 0 !important;
}

.cell-item {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.input-color {
  color: #999999 !important;
}

.todo-btn-show {
  .list-todo-btn {
    display: none;
  }
  &:hover {
    .list-todo-btn {
      display: block;
    }
  }
}
.list-todo-btn {
  width: fit-content !important;
}

.detail-custom-content {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  &-item {
    flex: 1;
    display: flex;
    align-items: center;
    border-right: solid 1px #EBEEF5;
    &:last-of-type {
      border-right: none;
    }
  }
}

.list-app-img {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  &-item {
    display: flex;
    align-items: center;
    margin-left: 5px;
    width: 28px;
    height: 28px;
    position: relative;
    overflow: hidden;
    .img-mask {
      transition: .3s;
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.48);
      left: 0;
      top: 0;
      transform: translateX(-100%);
      .el-icon-delete {
        font-size: 12px;
        cursor: pointer;
        color: #fff;
      }
    }
    &:hover {
      .img-mask {
        transform: translateX(0);
      }
    }
  }
  .todo-img {
    position: relative;
    overflow: hidden;
  }
  .todo-upload {
    width: 28px;
    height: 28px;
    border: solid 1px #DCDFE6;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}

.reload {
  position: absolute;
  bottom: 20PX;
  right: 20px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  background: #FFFFFF;
  box-shadow: -1px 3px 12px 1px rgba(15,5,10,0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
  .WSicon-zhongzhiicon{
    font-size: 20px;
  }
}


::v-deep .todo-number {
  width: 100%;
  line-height: 28px;
  .el-input-number__decrease {
    width: 15px;
    line-height: 13px;
    bottom: 3px;
  }
  .el-input-number__increase {
    width: 15px;
    line-height: 13px;
    top: 3px;
  }
  .el-input__inner {
    line-height: 28px;
    height: 28px;
    padding: 0 15px;
    text-align: left;
  }
}
::v-deep .todo-number-wy {
  width: 80%;
}
::v-deep .todo-date {
  .el-input__inner {
    line-height: 28px;
    height: 28px;
  }
  .el-input__icon {
    line-height: 28px;
  }
}

::v-deep .radio-switch {
  display: flex;
  align-items: center;
  height: 100%;
  .el-switch__label {
    white-space: nowrap;
  }
}


::v-deep .stat-block {
  line-height: 23px;
  height: auto;
}

.detail-custom-header {
  color: #4e86ff;
  position: absolute;
  font-size: 10px;
  cursor: pointer;
  .iconfont {
    font-size: 10px;
  }
}

.door-header {
  position: relative;
  .icon-you {
    font-size: 12px;
    color: #E1E1E1;
    transform: scale(.7);
    cursor: pointer;
    display: inline-block;
    transition: .3s;
    position: absolute;
    right: 0;
  }
  ::v-deep .order-and-screen {
    .icon-xia {
      opacity: 0;
    }
  }
  ::v-deep &:hover {
    .order-and-screen {
      .icon-xia {
        opacity: 1;
      }
    }
  }
  .trans {
    transform: rotate(180deg) scale(.7);
  }
}

.img-file {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
  .todo-upload {
    width: 28px;
    height: 28px;
    border: solid 1px #DCDFE6;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: auto;
  }
  .icon-wenjianfujian {
    color: #999999;
    font-size: 14px;
    position: absolute;
    left: 0;
    display: flex;
    align-items: center;
    height: 26px;
  }
  &-style {
    margin-left: 20px;
    display: flex;
    align-items: center;
    overflow: hidden;
    .el-icon-delete {
      color: #e47470;
      cursor: pointer;
    }
    .img-file-content {
      cursor: pointer;
      padding-right: 5px;
      color: #4e86ff;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
      // flex: 1;
      &:hover {
        text-decoration: underline;
      }
    }
    .img-file-icon {
      cursor: pointer;
      .icon-xiazai2x {
        font-size: 14px;
        color: #4e86ff;
      }
    }
  }
}

::v-deep .cell .el-button--small {
  padding: 0;
}
.list-search {
  display: inline-block;
  ::v-deep .el-input__inner {
    border-right: none;
    border-radius: 4px 0 0 4px;
  }
  ::v-deep .el-button {
    border-radius: 0 2px 2px 0;
    margin-left: -4px;
  }
}

::v-deep .el-table .cell {
  line-height: 26px;
}
/*
  ::v-deep .list-search input {
    background: #F2F2F2;
    border: none;
  }
*/
> #table-list .el-popover {
  background: #312d28;
  font-size: 14px;
  color: #ffffff;
  border: 1px solid #312d28;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
#table-list .el-popper[x-placement^="top"] .popper__arrow:after {
  border-top-color: #312d28;
}
::v-deep .el-table {
  .cell {
    overflow: hidden;
    text-overflow: initial;
    white-space: initial;
  }
}
#listMom .el-form-item {
  margin-bottom: 0;
}

.tmTibs .el-tabs__nav {
  margin-left: 30px;
  padding: 10px 0;
}
.tmTibs .el-tabs__nav .el-tabs__item {
  font-size: 16px !important;
}
.el-table .header_style {
  background: #f8f9fb;
}
.row_style {
  color: #000;
  cursor: pointer;
}
.switBox .time-managementList {
  width: 369px !important;
}
.switBox .time-managementList,
.switBox .time-managementList input,
.switBox input {
  background: #f7f7f7;
  border: 1px solid transparent;
}
.switBox input:hover {
  border: 1px solid #19b359;
  background: #ffffff;
}
.switBox .el-select .el-input.is-focus .el-input__inner {
  border-color: #19b359;
  background: #ffffff;
}
.switBox .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover,
.switBox .el-select-dropdown__item .hover {
  background: #f9fff9;
}
.switBox .time-managementList:hover,
.switBox .time-managementList:hover input {
  background: #ffffff;
  border: 1px solid #19b359;
}
.switBox .time-managementList:hover input {
  border: 1px solid transparent;
}
::v-deep .row_style_back {
  background-color: #f1f8ff !important;
}
::v-deep .row_style {
  height: 36px;
}
</style>
<style lang="scss" scoped>
::v-deep .dataArchiving {
  .icon-guidang {
    color: #9013FE !important;
  }
}
::v-deep .batch {
  margin-left: 20px;
  display: inline-block;
  .title {
    margin: 0 4px;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #333333;
    font-size: 14px;
  }
  .el-icon-arrow-down {
    font-size: 10px;
  }
}
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #965500;
  background: rgba(255, 253, 246, 1);
}
.button-list:hover .button-list-text {
  color: #965500;
}
.button-list {
  display: inline-block;
  margin-left: 25px;
  font-size: 16px;
}

.door-ellipsis {
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--line-);
  overflow: hidden;
}

.nowrap {
  white-space: nowrap;
}
.button-list-text {
  font-size: 14px;
  vertical-align: text-top;
}
.cor-400 {
  color: #ffb400;
}

.menuList {
  background: #f4f4f9;
  height: 100%;
  position: relative;
  z-index: 99;
}
.menuList > p {
  position: absolute;
  background: #fff;
  width: 26px;
  height: 26px;
  right: -13px;
  border-radius: 50%;
  border: 1px solid #ddd;
  top: 46%;
  cursor: pointer;
  z-index: 5;
  text-align: center;
  line-height: 26px;
}
.menuList > p i {
  color: #4e86ff;
  font-size: 14px;
}
.menuList ul {
  padding-top: 18px;
  overflow: hidden;
}

.todo-icon-color {
  color: #999 !important;
  &:hover {
    color: #4e86ff !important;
  }
}

.todo-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.todo-grid-four {
  grid-template-columns: repeat(4, 1fr);
}

.icon-guidang{
  &:hover {
    color: #4e86ff;;
  }
}

.menuList ul li {
  margin-right: 10px;
  display: block;
  padding: 10px 0 10px 42px;
  cursor: pointer;
  color: #333;
}
.menuList ul li.active {
  background: #d2d2e1;
  color: #000;
}
.menuList ul li:hover {
  background: #e0e0eb;
}
.content {
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0px;
  overflow: auto;
  left: 225px;
}
.demo-form-inline {
  float: left;
}

.page {
  position: absolute;
  bottom: -45px;
  padding: 6px 2% 6px 0;
  right: 0;
  width: 80%;
  // max-width: calc(100% - 350px);
  display: flex;
  justify-content: flex-end;
  background: #fff;
  z-index: 5;
}
.el-icon--right {
  padding: 0 10px;
}
.nopadding {
  padding: 0;
}

::v-deep .hidden-header {
  display: none;
}


.fullscreen-progress {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    z-index: 3000 !important; // 确保在最上层显示
    margin: 0 !important;
    transform: none !important;
}

::v-deep .table-todo{
  // width: 100%;
  height: 100%;
  min-height: 28px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  &-item {
    margin-right: 8px;
    height: 26px !important;
    width: initial !important;
    &:last-of-type {
      margin-right: 0;
    }
    .btn-popover {
      height: 26px !important;
      .container-btn-pop {
        .buttonStyle {
          height: 26px !important;
        }
      }
    }
  }
}
.table-todo-img-tip {
  display: flex;
  align-items: center;
  width: auto;
  height: 23px;
  margin-right: 8px;
  flex-shrink: 0;
}
.el-button+.el-button{
  margin-left: 0;
}


.dialog-body {
  padding: 16px;
}
.dialog-body .el-checkbox {
  padding-bottom: 12px;
}
.dialog-foot {
  padding: 10px 16px;
  border-top: 1px solid #eee;
  display: flex;
  align-items: center;
  &-btn {
    flex: 1;
    text-align: right;
  }
}
.searchRow {
  height: 40px;
  overflow: hidden;
}
.searchList {
  height: 40px;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.searchMore {
  text-align: center;
  font-size: 20px;
  color: #4e86ff;
}
.searchMore i {
  cursor: pointer;
}

::v-deep .el-button {
  font-weight: 400;
}
.nav-top {
  padding-top: 5px;
  position: relative;
  width: 100%;
  .nav-top-filter {
    padding-left: 30px;
    color: #333333;
    &:hover {
      color: #4e86ff;
    }
  }
}
.nav-top .top-set {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 40px;
}
.nav-top .top-set i {
  color: #999999;
}
.pos-list-mom-y {
  min-height: 65px;
  width: 100%;
}
.pos-list-mom {
  min-height: 38px;
  position: absolute;
  left: 7px;
  padding-left: 10px;
  z-index: 999;
  width: calc(100% - 20px);
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(235, 235, 235, 1);
  box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.16);
  padding-bottom: 15px;
}
.icon-bottom:after,
.icon-bottom-yes {
  content: ">>";
}
.icon-bottom {
  display: inline-block;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg) scale(1, 1.9);
  letter-spacing: -3px;
  font-size: 12px;
  color: #999999;
  position: relative;
  top: -3px;
}
.icon-bottom-yes {
  letter-spacing: -3px;
  font-size: 14px;
  color: #965500;
  display: block;
  -webkit-transform: rotate(-90deg) scale(1, 1.9);
  -moz-transform: rotate(-90deg) scale(1, 1.9);
  -ms-transform: rotate(-90deg) scale(1, 1.9);
  -o-transform: rotate(-90deg) scale(1, 1.9);
  transform: rotate(-90deg) scale(1, 1.9);
}
.mom-text-yes {
  display: inline-block;
  position: absolute;
  bottom: -35px;
  left: 50%;
  transform: translateX(-50%);
  width: 65px;
  height: 55px;
  padding-top: 10px;
  background: rgba(255, 246, 217, 1);
  border: 2px solid rgba(216, 166, 0, 1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 50%;
  text-align: center;
  color: #965500;
  font-size: 14px;
}
.mom-text-yes-title {
  padding-top: 8px;
  display: block;
}

.mom-text {
  width: 180px;
  color: #999999;
  font-size: 14px;
  padding-top: 11px;
  position: relative;
  left: 50%;
  margin-left: -90px;
  transform: translateX(-50%);
  display: inline-block;
}
.parting {
  width: 1px;
  height: 13px;
  background: #e5e5e5;
  display: inline-block;
  vertical-align: sub;
}
.goInfo {
  border: 1px solid #b66200;
  background: #fffcea;
  font-size: 14px;
  color: #b66200;
}
.text-remark {
  position: absolute;
  top: 0;
  left: 0;
  background: #312d28;
  color: #ffffff;
  font-size: 14px;
  padding: 10px;
}
.tranHeight {
  padding-bottom: 20px;
  width: 100%;
  /*padding-top: 10px;*/
}
.blockchain {
  display: inline-block;
  .change {
    cursor: pointer;
    i {
      color: #4e86ff;
      font-size: 110%;
    }
  }
}
.btn-query {
  color: #4E86FF;
  cursor: pointer;
}
.query-list {
  height: 100px;
  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>
